var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMba(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-216",
    d: "M77.66,249.59c-95.18,55-95.17,144,0,199s249.49,54.95,344.67,0,95.17-144,0-199S172.84,194.64,77.66,249.59Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-216",
    d: "M377.61,242.51l51.65-29.3a1.24,1.24,0,0,0,0-2.36L388,186.61a4.53,4.53,0,0,0-4.09,0l-51.65,29.3a1.25,1.25,0,0,0,0,2.36l41.32,24.24A4.53,4.53,0,0,0,377.61,242.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-216",
    d: "M350.85,452,299,422c-3.25-1.88-3.25-5,.06-6.89l32.15-18.53a13.26,13.26,0,0,1,12,0L395,426.4c3.31,1.91,3.31,5,0,6.93L362.92,452A13.27,13.27,0,0,1,350.85,452Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-216",
    d: "M427.68,407.41l-52-29.85c-3.26-1.88-3.26-5,.06-6.89L408,352.06a13.22,13.22,0,0,1,12,0l51.8,29.78c3.31,1.91,3.31,5,0,6.93l-32.09,18.67A13.27,13.27,0,0,1,427.68,407.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-216",
    d: "M54.57,350.71,182.39,424.5a12.48,12.48,0,0,0,11.29,0l206.21-119c3.12-1.8,3.12-4.72,0-6.52l-127.82-73.8a12.5,12.5,0,0,0-11.3,0L54.57,344.18C51.45,346,51.45,348.9,54.57,350.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-216",
    d: "M220,467.09l-10.73-12.2h0l-80.85-46.84h0l-2.27-1.32-3.71-2.14-.26-.15.09,0-3.57-2.05v0L104.06,394c-2.82-1.93-7,2-8.68,5.92h0a10.48,10.48,0,0,0-.57,1.84c-.32,1.63,0,3.11,1.17,3.94l11.9,6.85,3.23,1.86s0,0,0,0l2.67,1.54.25.13,3.08,1.78h0a.45.45,0,0,0,.13.1l2.59,1.47,82.23,47.64h0l15.66,3.1,4.26.84a.64.64,0,0,0,.54-.15.62.62,0,0,0,0-.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-216",
    d: "M70.88,378.19c9.78,5.71,9.78,15,0,20.68s-25.64,5.71-35.42,0-9.79-15,0-20.68S61.1,372.48,70.88,378.19Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.93,114.32a3.4,3.4,0,0,1-.46-.08l-4.59-1.17a2.66,2.66,0,0,1-1.71-1.35,2.59,2.59,0,0,1-.07-2.18l3.37-8.37A2,2,0,0,0,94,99.32a13.2,13.2,0,0,1-1.24-1.63.77.77,0,0,0-1-.31l-6.25,3.85a2.13,2.13,0,0,1-3.37-1.58l-1-6.73A4.76,4.76,0,0,1,82.64,89L89,83.54a4.69,4.69,0,0,0,1.24-2.36,41.86,41.86,0,0,1,.92-4.56,1.2,1.2,0,0,0-.59-1.32L87,73.66a2.83,2.83,0,0,1-1.36-3.79l4.47-9.26a3.87,3.87,0,0,1,3.62-2.08l4.44.36a2.57,2.57,0,0,0,1.94-.92c1.08-1.49,2.23-2.92,3.4-4.24a4.23,4.23,0,0,0,.92-2.44l-.22-6.59A4.88,4.88,0,0,1,106,40.93l7.09-5.24a2.33,2.33,0,0,1,2.13-.4,2.3,2.3,0,0,1,1.42,1.64l1.41,5.23a.59.59,0,0,0,.26.36.65.65,0,0,0,.53,0,23.79,23.79,0,0,1,3-.89,3.55,3.55,0,0,0,2-1.39l4.6-8.15a3.55,3.55,0,0,1,3.81-1.64l4.59,1.17a2.6,2.6,0,0,1,1.79,3.54l-3.38,8.36a2.06,2.06,0,0,0,.44,1.86A13.4,13.4,0,0,1,137,47a.75.75,0,0,0,1,.31l6.25-3.85a2.14,2.14,0,0,1,3.38,1.59l.95,6.72a4.73,4.73,0,0,1-1.47,3.92l-6.3,5.46a4.58,4.58,0,0,0-1.24,2.36,43.08,43.08,0,0,1-.93,4.57,1.2,1.2,0,0,0,.59,1.31L142.76,71a2.79,2.79,0,0,1,1.48,1.61,2.76,2.76,0,0,1-.12,2.18l-4.46,9.26A3.88,3.88,0,0,1,136,86.16l-4.45-.35a2.58,2.58,0,0,0-1.94.92c-1.07,1.48-2.22,2.91-3.4,4.24a4.19,4.19,0,0,0-.91,2.43l.22,6.6a4.89,4.89,0,0,1-1.83,3.76L116.65,109a2.19,2.19,0,0,1-3.56-1.24l-1.41-5.23a.52.52,0,0,0-.26-.36.65.65,0,0,0-.53,0,22.63,22.63,0,0,1-3,.9,3.48,3.48,0,0,0-2,1.39l-4.59,8.15A3.59,3.59,0,0,1,97.93,114.32ZM92.37,95.21a2.93,2.93,0,0,1,2.15,1.34,11.43,11.43,0,0,0,1.06,1.38,4.07,4.07,0,0,1,.82,4L93,110.31a.55.55,0,0,0,0,.47.56.56,0,0,0,.38.28L98,112.23a1.48,1.48,0,0,0,1.5-.64l4.59-8.15a5.55,5.55,0,0,1,3.36-2.4,19.78,19.78,0,0,0,2.74-.82,2.71,2.71,0,0,1,2.2.11,2.55,2.55,0,0,1,1.32,1.66l1.41,5.23c0,.15.09.21.11.22a.64.64,0,0,0,.2-.11l7.09-5.23a2.9,2.9,0,0,0,1-2l-.22-6.59a6.22,6.22,0,0,1,1.44-3.88c1.13-1.28,2.23-2.65,3.28-4.08a4.58,4.58,0,0,1,3.78-1.77l4.44.35a1.84,1.84,0,0,0,1.59-.91l4.46-9.26a.73.73,0,0,0,0-.58.72.72,0,0,0-.39-.43l-3.55-1.64a3.28,3.28,0,0,1-1.73-3.72,38.38,38.38,0,0,0,.88-4.34,6.69,6.69,0,0,1,1.94-3.63l6.3-5.46a2.63,2.63,0,0,0,.77-2h0l-.95-6.72a.59.59,0,0,0-.06-.2,1.58,1.58,0,0,0-.17.09l-6.25,3.85a2.81,2.81,0,0,1-3.86-.94,11.94,11.94,0,0,0-1.05-1.38,4,4,0,0,1-.82-4l3.37-8.36a.59.59,0,0,0,0-.47.55.55,0,0,0-.38-.27l-4.59-1.17a1.45,1.45,0,0,0-1.49.64l-4.59,8.14a5.54,5.54,0,0,1-3.37,2.4,22.24,22.24,0,0,0-2.74.82,2.67,2.67,0,0,1-2.2-.11,2.54,2.54,0,0,1-1.31-1.66l-1.41-5.23a.44.44,0,0,0-.11-.22.78.78,0,0,0-.21.11l-7.08,5.24a2.79,2.79,0,0,0-1,2l.21,6.6A6.31,6.31,0,0,1,105,55.11a51.74,51.74,0,0,0-3.28,4.08A4.64,4.64,0,0,1,98,61l-4.45-.35a1.8,1.8,0,0,0-1.58.9l-4.47,9.26a.76.76,0,0,0,.36,1l3.56,1.64a3.3,3.3,0,0,1,1.73,3.72,39.85,39.85,0,0,0-.89,4.34,6.58,6.58,0,0,1-1.93,3.63L84,90.57a2.72,2.72,0,0,0-.77,2.06l1,6.72a.68.68,0,0,0,0,.2,1.33,1.33,0,0,0,.18-.09l6.25-3.85A2.67,2.67,0,0,1,92.37,95.21ZM107.52,91a8,8,0,0,1-2.41-.6c-2.81-1.17-4.65-3.88-5.18-7.62-1.16-8.25,4.35-19.73,12.29-25.6,4.42-3.27,8.94-4.32,12.41-2.87,2.8,1.18,4.64,3.88,5.17,7.62,1.17,8.25-4.34,19.74-12.28,25.61h0C114.06,90.08,110.54,91.28,107.52,91ZM122,55.77c-2.5-.24-5.51.82-8.55,3.07C106.06,64.3,100.92,74.91,102,82.48c.43,3,1.79,5.1,3.92,6,2.77,1.15,6.55.2,10.37-2.62,7.4-5.47,12.54-16.07,11.46-23.65-.43-3-1.78-5.1-3.91-6A6.14,6.14,0,0,0,122,55.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.94,79.73a1.91,1.91,0,0,1-.33-.06l-3-.78a1.88,1.88,0,0,1-1.25-1,1.93,1.93,0,0,1,0-1.58l2.24-5.55a1.19,1.19,0,0,0-.26-1.07,9.25,9.25,0,0,1-.84-1.09c-.08-.12-.27-.29-.47-.16L155.79,71a1.58,1.58,0,0,1-2.49-1.16l-.63-4.47a3.32,3.32,0,0,1,1-2.75L157.88,59a2.88,2.88,0,0,0,.78-1.47,26.89,26.89,0,0,1,.62-3,.63.63,0,0,0-.31-.68l-2.36-1.09a2,2,0,0,1-1-2.74l3-6.15a2.73,2.73,0,0,1,2.56-1.47l3,.23a1.51,1.51,0,0,0,1.14-.55c.72-1,1.48-1.93,2.27-2.82a2.68,2.68,0,0,0,.57-1.5L168,33.33a3.41,3.41,0,0,1,1.27-2.63l4.71-3.48a1.68,1.68,0,0,1,1.57-.29,1.73,1.73,0,0,1,1.05,1.2l.93,3.47c.15.17.23.16.31.13a17,17,0,0,1,2-.6,2.18,2.18,0,0,0,1.22-.84l3.05-5.42a2.5,2.5,0,0,1,2.72-1.16l3,.78a1.89,1.89,0,0,1,1.3,2.56l-2.25,5.56a1.18,1.18,0,0,0,.27,1.06,9.37,9.37,0,0,1,.84,1.1.35.35,0,0,0,.46.16l4.15-2.56a1.66,1.66,0,0,1,1.59-.14,1.61,1.61,0,0,1,.9,1.31l.63,4.47a3.31,3.31,0,0,1-1,2.75l-4.19,3.62a2.94,2.94,0,0,0-.77,1.47,27.51,27.51,0,0,1-.62,3,.63.63,0,0,0,.3.68l2.36,1.09a2,2,0,0,1,1,2.74l-3,6.15A2.76,2.76,0,0,1,189.25,61l-2.95-.24a1.58,1.58,0,0,0-1.14.55c-.71,1-1.48,1.93-2.27,2.83a2.55,2.55,0,0,0-.56,1.5l.14,4.38a3.44,3.44,0,0,1-1.28,2.64l-4.7,3.48a1.62,1.62,0,0,1-2.62-.92l-.93-3.47c-.16-.17-.23-.16-.31-.13a16.06,16.06,0,0,1-2,.6,2.23,2.23,0,0,0-1.22.85l-3,5.41A2.54,2.54,0,0,1,163.94,79.73Zm-3.66-13a2.11,2.11,0,0,1,1.55,1,6.8,6.8,0,0,0,.69.89,2.87,2.87,0,0,1,.57,2.85L160.85,77l.14.27,3,.78a.78.78,0,0,0,.8-.35l3.06-5.41a3.83,3.83,0,0,1,2.33-1.67,13.09,13.09,0,0,0,1.8-.54,2,2,0,0,1,1.6.08,1.86,1.86,0,0,1,1,1.21l.94,3.47,4.66-3.49a1.72,1.72,0,0,0,.58-1.21l-.14-4.39a4.35,4.35,0,0,1,1-2.69c.76-.85,1.49-1.76,2.17-2.69a3.24,3.24,0,0,1,2.66-1.25l2.95.24a1.07,1.07,0,0,0,.89-.51l3-6.15a.34.34,0,0,0,0-.26.29.29,0,0,0-.18-.19l-2.35-1.09a2.35,2.35,0,0,1-1.24-2.66,26.06,26.06,0,0,0,.58-2.87,4.63,4.63,0,0,1,1.34-2.51l4.19-3.62a1.63,1.63,0,0,0,.45-1.22h0l-.64-4.46-4,2.6a2,2,0,0,1-2.79-.67,7.85,7.85,0,0,0-.68-.9,2.88,2.88,0,0,1-.58-2.84l2.24-5.56.07-.21-.2-.06-3.05-.77a.79.79,0,0,0-.81.34l-3,5.41a3.84,3.84,0,0,1-2.34,1.68,15.08,15.08,0,0,0-1.8.53,2,2,0,0,1-1.59-.08,1.85,1.85,0,0,1-1-1.2l-.93-3.48-4.66,3.5a1.74,1.74,0,0,0-.59,1.21l.14,4.38a4.33,4.33,0,0,1-1,2.69c-.75.85-1.48,1.76-2.16,2.7A3.26,3.26,0,0,1,164,44.29L161,44.06a1.06,1.06,0,0,0-.9.51l-3,6.15a.35.35,0,0,0,0,.26.36.36,0,0,0,.18.19l2.36,1.09a2.35,2.35,0,0,1,1.24,2.66,23.78,23.78,0,0,0-.58,2.86A4.55,4.55,0,0,1,159,60.29l-4.18,3.63a1.63,1.63,0,0,0-.46,1.22l.63,4.47L159.05,67A2,2,0,0,1,160.28,66.71Zm10-2.47a5.71,5.71,0,0,1-1.65-.41,6.21,6.21,0,0,1-3.53-5.19c-.79-5.53,2.9-13.23,8.22-17.16,3-2.21,6.05-2.91,8.4-1.92a6.19,6.19,0,0,1,3.54,5.19c.78,5.53-2.91,13.22-8.22,17.15h0A10.16,10.16,0,0,1,170.31,64.24Zm9.62-23.4a8.48,8.48,0,0,0-5.56,2c-4.87,3.6-8.26,10.57-7.55,15.55a4.5,4.5,0,0,0,2.5,3.85c1.78.75,4.24.12,6.73-1.72h0C180.92,56.94,184.3,50,183.6,45c-.28-2-1.15-3.29-2.51-3.86A4,4,0,0,0,179.93,40.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.42,338.71c0,3.19,2.39,5.24,5.34,6.94l120.76,69.72a11.8,11.8,0,0,0,10.67,0L389,302.89c2.95-1.7,5.34-3.89,5.34-7.08s-2.39-5.17-5.34-6.87L268.24,219.22a11.8,11.8,0,0,0-10.67,0L62.76,331.7C59.81,333.4,57.42,335.52,57.42,338.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.76,337.86l120.76,69.72a11.8,11.8,0,0,0,10.67,0L389,295.1c2.95-1.7,2.95-4.46,0-6.16L268.24,219.22a11.8,11.8,0,0,0-10.67,0L62.76,331.7C59.81,333.4,59.81,336.16,62.76,337.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.86,408.87v7.77a10.9,10.9,0,0,1-5.34-1.27L62.76,345.65c-2.95-1.7-5.34-3.75-5.34-6.94,0-3,2.15-5.08,4.92-6.77-2.29,1.61-2.33,4.33.42,5.92l120.76,69.72A10.9,10.9,0,0,0,188.86,408.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.23,332.6l179-103.36a5.57,5.57,0,0,1,5,0l6.52,3.66c1.39.8,1.39,2.1,0,2.91l-179,103.34a5.57,5.57,0,0,1-5,0l-6.5-3.64C77.84,334.71,77.84,333.41,79.23,332.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.82,343l179-103.36a5.16,5.16,0,0,1,4.6-.25L327,266.27c1.15.66,1,1.85-.43,2.65L147.78,372.14a5.16,5.16,0,0,1-4.6.26L96.39,345.62C95.23,345,95.43,343.78,96.82,343Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.94,283l5.61-3.24c.24-.14.26-.35.05-.47l-5.37-3.1a.89.89,0,0,0-.81,0l-5.61,3.24c-.23.13-.26.34,0,.47l5.36,3.09A.89.89,0,0,0,251.94,283Zm-8.18-11.2-5.61,3.23c-.23.14-.26.35,0,.47l5.36,3.1a.89.89,0,0,0,.81,0l5.61-3.23c.24-.14.26-.35.05-.47l-5.37-3.1A.89.89,0,0,0,243.76,271.83Zm-18.11,10.45-9.49,5.48c-.23.14-.26.35,0,.47l5.36,3.1a.89.89,0,0,0,.81,0l9.49-5.48c.24-.14.26-.35.05-.47l-5.37-3.09A.89.89,0,0,0,225.65,282.28Zm9.92-5.72L230,279.79c-.24.14-.26.35-.05.47l5.37,3.1a.89.89,0,0,0,.81,0l5.6-3.23c.24-.14.26-.35.05-.47l-5.36-3.1A.89.89,0,0,0,235.57,276.56Zm-22,12.69L208,292.49c-.24.14-.26.35-.05.47l5.37,3.1a.89.89,0,0,0,.81,0l5.61-3.24c.23-.14.25-.35,0-.47l-5.36-3.09A.89.89,0,0,0,213.58,289.25Zm-8.2,4.73-5.6,3.24c-.24.14-.26.35-.05.47l5.36,3.1a.91.91,0,0,0,.82,0l5.6-3.24c.24-.14.26-.35.05-.47L206.2,294A.91.91,0,0,0,205.38,294Zm21,12.64,5.61-3.24c.24-.14.26-.35.05-.47l-5.37-3.1a.93.93,0,0,0-.81,0l-5.61,3.24c-.23.14-.26.35,0,.47l5.36,3.09A.89.89,0,0,0,226.4,306.62Zm-8.19,4.73,5.61-3.24c.23-.14.26-.35,0-.47l-5.36-3.1a.89.89,0,0,0-.81,0l-5.61,3.24c-.24.14-.26.35-.05.47l5.37,3.09A.89.89,0,0,0,218.21,311.35ZM210,316.08l5.6-3.24c.24-.14.26-.35,0-.47l-5.36-3.1a.91.91,0,0,0-.82,0l-5.6,3.24c-.24.14-.26.35,0,.47l5.36,3.09A.91.91,0,0,0,210,316.08Zm-8.19,4.73,5.6-3.24c.24-.14.26-.35,0-.47l-5.36-3.1a.91.91,0,0,0-.82,0l-5.6,3.24c-.24.14-.26.35,0,.47l5.36,3.09A.91.91,0,0,0,201.83,320.81Zm41.92-33.05,5.61-3.24c.23-.14.26-.35,0-.47L244,281a.89.89,0,0,0-.81,0l-5.61,3.24c-.24.13-.26.35-.05.47l5.37,3.09A.89.89,0,0,0,243.75,287.76Zm-9.15,14.13,12.5-7.22c.24-.14.26-.35.05-.47l-13-7.52a.89.89,0,0,0-.81,0l-6.47,3.73c-.24.14-.26.35-.05.47l6.9,4c.21.12.19.33-.05.47l-5.17,3c-.24.14-.26.35-.05.47l5.36,3.09A.91.91,0,0,0,234.6,301.89Zm-37.41-3.18-5.6,3.24c-.24.14-.26.35-.05.47l5.36,3.1a.89.89,0,0,0,.81,0l5.61-3.24c.24-.14.26-.35.05-.47L198,298.69A.91.91,0,0,0,197.19,298.71ZM189,303.44l-5.61,3.24c-.23.14-.26.35,0,.47l5.36,3.1a.89.89,0,0,0,.81,0l5.61-3.24c.24-.14.26-.35.05-.47l-5.37-3.09A.89.89,0,0,0,189,303.44Zm-45.33,50.5a.89.89,0,0,0,.81,0l5.6-3.24c.24-.14.26-.35,0-.47l-5.36-3.1a.89.89,0,0,0-.81,0l-5.61,3.24c-.24.13-.26.35,0,.47Zm-20.21-12.66-5.61,3.24c-.23.14-.26.35,0,.47l5.36,3.09a.89.89,0,0,0,.81,0l5.61-3.24c.24-.14.26-.35,0-.47l-5.37-3.09A.86.86,0,0,0,123.46,341.28Zm10.39,9.49a.89.89,0,0,0,.81,0l5.61-3.24c.24-.14.26-.35,0-.47L135,343.94a.89.89,0,0,0-.81,0l-5.61,3.24c-.23.14-.26.35,0,.47Zm22.6,5.08,5.61-3.24c.24-.13.26-.34.05-.47l-5.37-3.09a.86.86,0,0,0-.81,0l-5.61,3.23c-.23.14-.26.35,0,.47l5.36,3.1A.89.89,0,0,0,156.45,355.85Zm-9,4.76a.89.89,0,0,0,.81,0l5.6-3.24c.24-.13.26-.34,0-.47l-5.36-3.09a.89.89,0,0,0-.81,0L142.13,357c-.24.14-.26.35,0,.47Zm-15.8-24.06-5.6,3.24c-.24.14-.26.35,0,.47l5.36,3.09a.91.91,0,0,0,.82,0l5.6-3.24c.24-.14.26-.35.05-.47l-5.36-3.1A1,1,0,0,0,131.65,336.55Zm41-23.65-5.6,3.24c-.24.14-.26.35,0,.47l5.36,3.1a.91.91,0,0,0,.82,0l5.6-3.24c.24-.14.26-.35,0-.47l-5.36-3.09A.91.91,0,0,0,172.61,312.9Zm-32.77,18.92-5.6,3.24c-.24.14-.26.35-.05.47l5.36,3.09a.88.88,0,0,0,.82,0l5.6-3.24c.24-.14.26-.35.05-.47l-5.36-3.1A1,1,0,0,0,139.84,331.82Zm41-23.65-5.61,3.24c-.24.14-.26.35,0,.47l5.37,3.1a.89.89,0,0,0,.81,0l5.61-3.24c.23-.14.25-.35,0-.47l-5.36-3.09A.89.89,0,0,0,180.81,308.17Zm-16.39,9.46-5.6,3.24c-.24.14-.26.35,0,.47l5.36,3.1a.91.91,0,0,0,.82,0l5.6-3.24c.24-.14.26-.35,0-.47l-5.36-3.09A.91.91,0,0,0,164.42,317.63Zm-8.19,4.73-5.61,3.24c-.23.14-.26.35,0,.47l5.36,3.1a.93.93,0,0,0,.81,0l5.61-3.24c.24-.14.26-.35,0-.47l-5.37-3.1A.93.93,0,0,0,156.23,322.36ZM148,327.09l-5.61,3.24c-.24.14-.26.35-.05.47l5.37,3.1a.93.93,0,0,0,.81,0l5.61-3.24c.23-.14.26-.35,0-.47l-5.36-3.09A.89.89,0,0,0,148,327.09Zm37.4,3.18,5.61-3.24c.23-.14.26-.35,0-.47l-5.36-3.1a.89.89,0,0,0-.81,0l-5.61,3.24c-.24.14-.26.35-.05.47l5.37,3.09A.89.89,0,0,0,185.44,330.27Zm76.43-68.9-5.61,3.24c-.24.14-.26.35-.05.47l5.37,3.09a.89.89,0,0,0,.81,0l5.61-3.24c.24-.14.26-.35.05-.47l-5.37-3.1A.93.93,0,0,0,261.87,261.37ZM252,267.1l-5.6,3.23c-.24.14-.26.35,0,.47l5.36,3.1a.89.89,0,0,0,.81,0l5.61-3.23c.24-.14.26-.35.05-.47l-5.36-3.1A.91.91,0,0,0,252,267.1Zm18.11-10.46-5.6,3.24c-.24.14-.26.35,0,.47l5.36,3.09a.89.89,0,0,0,.81,0l5.61-3.24c.24-.14.26-.35.05-.47l-5.36-3.1A.91.91,0,0,0,270.06,256.64Zm-45.28,42.07,5.6-3.24c.24-.13.26-.35.05-.47l-5.36-3.09a.89.89,0,0,0-.81,0l-5.61,3.24c-.24.14-.26.35-.05.47l5.36,3.1A.91.91,0,0,0,224.78,298.71Zm54.29-46.83a1,1,0,0,0-.82,0l-5.6,3.24c-.24.14-.26.35,0,.47l5.36,3.1a1,1,0,0,0,.82,0l5.6-3.24c.24-.14.26-.35.05-.47Zm-85.44,73.66,5.61-3.24c.24-.14.26-.35,0-.47l-5.37-3.1a.89.89,0,0,0-.81,0L187.5,322c-.23.14-.25.35,0,.47l5.36,3.09A.89.89,0,0,0,193.63,325.54Zm100.47-58,5.6-3.23c.24-.14.26-.35.05-.47l-5.36-3.1a.91.91,0,0,0-.82,0L288,264c-.24.14-.26.35-.05.48l5.36,3.09A.91.91,0,0,0,294.1,267.53Zm-15.85.31,5.6-3.24c.24-.13.26-.34,0-.47L278.54,261a.91.91,0,0,0-.82,0l-5.6,3.23c-.24.14-.26.35-.05.47l5.36,3.1A.91.91,0,0,0,278.25,267.84Zm8.48-11.53a.91.91,0,0,0-.82,0l-5.6,3.23c-.24.14-.26.35-.05.47l5.36,3.1a.91.91,0,0,0,.82,0l5.6-3.24c.24-.13.26-.34,0-.47Zm1.72-1,13,7.52a.89.89,0,0,0,.81,0l5.61-3.23c.23-.14.26-.35,0-.47l-13-7.52a.89.89,0,0,0-.81,0l-5.61,3.23C288.26,255,288.24,255.19,288.45,255.31ZM269.53,265.8,263.92,269c-.23.14-.26.35,0,.47l5.36,3.1a.89.89,0,0,0,.81,0l5.61-3.24c.24-.13.26-.34,0-.47l-5.37-3.09A.89.89,0,0,0,269.53,265.8Zm-61.66,35.59-5.6,3.24c-.24.14-.26.35-.05.47l5.36,3.1a.89.89,0,0,0,.81,0l5.61-3.24c.24-.14.26-.35.05-.47l-5.36-3.09A.91.91,0,0,0,207.87,301.39Zm77.22-29.1a.91.91,0,0,0,.82,0l5.6-3.23c.24-.14.26-.35.05-.47l-5.36-3.1a.91.91,0,0,0-.82,0l-5.6,3.23c-.24.14-.26.35,0,.47Zm-69,24.37-5.6,3.24c-.24.14-.26.35-.05.47l5.36,3.1a.91.91,0,0,0,.82,0l5.6-3.24c.24-.13.26-.35.05-.47l-5.36-3.09A.91.91,0,0,0,216.06,296.66Zm-64.2,52.55a.89.89,0,0,0,.81,0l5.61-3.24c.23-.14.26-.35,0-.47l-5.36-3.1a.89.89,0,0,0-.81,0l-5.61,3.24c-.23.13-.26.35,0,.47Zm-9.53-10-5.6,3.24c-.24.14-.26.35,0,.47L142,346a.93.93,0,0,0,.81,0l5.61-3.24c.24-.14.26-.35,0-.47l-5.36-3.1A1,1,0,0,0,142.33,339.23Zm18.53,5.23,5.61-3.24c.24-.14.26-.35.05-.47l-5.37-3.1a.89.89,0,0,0-.81,0l-5.6,3.24c-.24.13-.26.35-.05.47l5.36,3.09A.89.89,0,0,0,160.86,344.46Zm8.2-4.73,5.6-3.24c.24-.14.26-.35.05-.47l-5.36-3.1a.91.91,0,0,0-.82,0l-5.6,3.24c-.24.14-.26.35-.05.47l5.36,3.09A.91.91,0,0,0,169.06,339.73Zm8.19-4.73,5.6-3.24c.24-.14.26-.35.05-.47l-5.36-3.1a.89.89,0,0,0-.81,0l-5.61,3.24c-.24.13-.26.35-.05.47l5.36,3.09A.91.91,0,0,0,177.25,335Zm-26.73-.5-5.6,3.24c-.24.14-.26.35,0,.47l5.36,3.1a.91.91,0,0,0,.82,0l5.6-3.24c.24-.14.26-.35,0-.47l-5.36-3.09A.91.91,0,0,0,150.52,334.5Zm8.2-4.73L153.11,333c-.24.14-.26.35-.05.47l5.37,3.1a.89.89,0,0,0,.81,0l5.61-3.24c.23-.14.25-.35,0-.47l-5.36-3.09A.89.89,0,0,0,158.72,329.77Zm32.77-18.92-5.61,3.24c-.24.14-.26.35,0,.47l5.36,3.1a.91.91,0,0,0,.82,0l5.6-3.24c.24-.14.26-.35,0-.47l-5.36-3.09A.89.89,0,0,0,191.49,310.85Zm-8.2,4.73-5.6,3.24c-.24.14-.26.35-.05.47l5.36,3.1a.91.91,0,0,0,.82,0l5.6-3.24c.24-.14.26-.35.05-.47l-5.36-3.09A.91.91,0,0,0,183.29,315.58Zm16.39-9.46-5.61,3.24c-.24.14-.26.35,0,.47l5.37,3.1a.89.89,0,0,0,.81,0l5.61-3.24c.24-.14.26-.35,0-.47l-5.36-3.09A.89.89,0,0,0,199.68,306.12ZM166.91,325l-5.61,3.24c-.23.14-.26.35,0,.47l5.36,3.1a.89.89,0,0,0,.81,0l5.61-3.24c.24-.14.26-.35.05-.47L167.72,325A.89.89,0,0,0,166.91,325Zm8.19-4.73-5.6,3.24c-.24.14-.26.35-.05.47l5.36,3.1a.89.89,0,0,0,.81,0l5.61-3.24c.24-.14.26-.35.05-.47l-5.36-3.09A.91.91,0,0,0,175.1,320.31Zm-10.46,30.81,5.61-3.24c.24-.13.26-.34.05-.47l-5.36-3.09a.91.91,0,0,0-.82,0l-5.6,3.24c-.24.14-.26.35-.05.47l5.36,3.1A.89.89,0,0,0,164.64,351.12Zm-43.2-2-5.36-3.1a.89.89,0,0,0-.81,0l-5.61,3.24c-.24.14-.26.35,0,.47l5.37,3.09a.89.89,0,0,0,.81,0l5.61-3.24C121.63,349.41,121.66,349.2,121.44,349.08Zm10.68,2.68-5.36-3.09a.89.89,0,0,0-.81,0l-8.63,5c-.24.14-.26.35,0,.47l5.36,3.1a.89.89,0,0,0,.81,0l8.63-5C132.31,352.09,132.33,351.88,132.12,351.76ZM113.44,343l-5.36-3.1a.91.91,0,0,0-.82,0l-6.9,4c-.23.14-.26.35,0,.47l5.36,3.1a.89.89,0,0,0,.81,0l6.9-4C113.63,343.3,113.65,343.09,113.44,343Zm5.29-3.06a.89.89,0,0,0,.81,0l5.61-3.23c.24-.14.26-.35,0-.47l-5.37-3.1a.89.89,0,0,0-.81,0l-5.6,3.24c-.24.13-.26.34,0,.47Zm23.21,15-5.36-3.1a.91.91,0,0,0-.82,0L125,358.09c-.23.14-.26.35,0,.47l5.36,3.1a.89.89,0,0,0,.81,0l10.78-6.22C142.13,355.27,142.15,355.06,141.94,354.94Zm3.78,6.66-5.36-3.09a.91.91,0,0,0-.82,0l-6.89,4c-.24.13-.26.35-.05.47l5.36,3.09a.89.89,0,0,0,.81,0l6.9-4C145.91,361.94,145.93,361.72,145.72,361.6Zm33.92-56.85a.93.93,0,0,0,.81,0l5.61-3.24c.24-.14.26-.35.05-.47l-5.36-3.09a.91.91,0,0,0-.82,0l-5.6,3.24c-.24.14-.26.35-.05.47Zm-16.38,9.45a.89.89,0,0,0,.81,0l5.61-3.24c.23-.14.25-.35,0-.47l-5.36-3.1a.93.93,0,0,0-.81,0l-5.61,3.24c-.24.14-.26.35-.05.47Zm-36.34,21a.91.91,0,0,0,.82,0l5.6-3.23c.24-.14.26-.35,0-.47l-5.36-3.1a.91.91,0,0,0-.82,0l-5.6,3.24c-.24.13-.26.34,0,.47Zm44.53-25.71a.86.86,0,0,0,.81,0l5.61-3.24c.24-.14.26-.35,0-.47l-5.37-3.1a.89.89,0,0,0-.81,0l-5.61,3.24c-.23.14-.26.35,0,.47Zm-16.39,9.47a1,1,0,0,0,.82,0l5.6-3.24c.24-.14.26-.35.05-.47l-5.36-3.1a.91.91,0,0,0-.82,0l-5.6,3.24c-.24.14-.26.35-.05.47Zm-5.32,43a.89.89,0,0,0-.81,0l-8.62,5c-.24.14-.26.35-.05.47l5.36,3.1a.89.89,0,0,0,.81,0l8.63-5c.24-.14.26-.35.05-.47Zm-6.43-36.21a.89.89,0,0,0,.81,0l5.61-3.23c.23-.14.26-.35,0-.47l-5.36-3.1a.89.89,0,0,0-.81,0L138,322.16c-.24.13-.26.34-.05.47Zm-8.2,4.73a.91.91,0,0,0,.82,0l5.6-3.23c.24-.14.26-.35.05-.47l-5.36-3.1a.91.91,0,0,0-.82,0l-5.6,3.24c-.24.13-.26.34-.05.47Zm166.41-56.14a.91.91,0,0,0-.82,0l-13.79,8c-.24.14-.26.35-.05.47l5.36,3.1a.91.91,0,0,0,.82,0l13.79-8c.24-.13.26-.35.05-.47Zm-18.11,10.45a.91.91,0,0,0-.82,0L277,288c-.24.13-.26.34-.05.47l5.36,3.09a.91.91,0,0,0,.82,0l5.6-3.23c.24-.14.26-.35,0-.47ZM172.84,346.39l5.6-3.24c.24-.13.26-.34.05-.47l-5.36-3.09a.91.91,0,0,0-.82,0l-5.6,3.24c-.24.14-.26.35-.05.47l5.36,3.1A.91.91,0,0,0,172.84,346.39ZM267,294.22a.89.89,0,0,0-.81,0l-5.61,3.24c-.23.13-.26.34,0,.47l5.36,3.09a.89.89,0,0,0,.81,0l5.61-3.23c.24-.14.26-.35.05-.47Zm42.69-24.64a.89.89,0,0,0-.81,0l-5.61,3.24c-.24.14-.26.35-.05.47l5.37,3.1a.89.89,0,0,0,.81,0l5.6-3.24c.24-.13.26-.34.05-.47Zm13.56-1.64-13-7.52a.89.89,0,0,0-.81,0l-5.61,3.24c-.24.14-.26.35-.05.47l13,7.52a.89.89,0,0,0,.81,0l5.61-3.24C323.46,268.28,323.48,268.07,323.27,267.94Zm-86.86,44a.89.89,0,0,0-.81,0l-6.9,4c-.24.13-.26.35,0,.47l5.36,3.09a.91.91,0,0,0,.82,0l6.89-4c.24-.13.26-.35.05-.47ZM257.11,300a.91.91,0,0,0-.82,0l-8.62,5c-.24.14-.26.35,0,.47l5.36,3.1a.91.91,0,0,0,.82,0l8.62-5c.24-.13.26-.34.05-.47Zm-39.67,22.9a.91.91,0,0,0-.82,0l-46.13,26.63c-.24.14-.26.35-.05.47l5.36,3.1a.91.91,0,0,0,.82,0l46.13-26.63c.24-.14.26-.35.05-.47ZM168.72,351a.91.91,0,0,0-.82,0l-6.9,4c-.24.14-.26.35-.05.47l5.37,3.1a.89.89,0,0,0,.81,0l6.9-4c.24-.14.26-.35.05-.47Zm58.2-33.61a.89.89,0,0,0-.81,0l-6.9,4c-.24.14-.26.35-.05.47l5.37,3.1a.89.89,0,0,0,.81,0l6.9-4c.24-.14.26-.35,0-.47Zm-67.69,39.09a.89.89,0,0,0-.81,0l-6.9,4c-.24.14-.26.35-.05.47l5.36,3.09a.89.89,0,0,0,.81,0l6.9-4c.24-.13.26-.34.05-.47Zm86.67-50a.91.91,0,0,0-.82,0l-6.9,4c-.23.14-.26.35,0,.47l5.36,3.1a.89.89,0,0,0,.81,0l6.9-4c.24-.14.26-.35,0-.47Zm29.32-16.93a.91.91,0,0,0-.82,0l-5.6,3.24c-.24.13-.26.34-.05.47l5.36,3.09a.91.91,0,0,0,.82,0l5.6-3.23c.24-.14.26-.35.05-.47Zm18.35-12.8,5.6-3.24c.24-.14.26-.35.05-.47l-5.36-3.1a.91.91,0,0,0-.82,0l-5.6,3.24c-.24.13-.26.35-.05.47l5.36,3.09A.91.91,0,0,0,293.57,276.69Zm-33.43,1.61,5.6-3.24c.24-.14.26-.35.05-.47l-5.36-3.1a.91.91,0,0,0-.82,0l-5.6,3.24c-.24.14-.26.35,0,.47l5.36,3.09A.91.91,0,0,0,260.14,278.3Zm-21.76,30.25,16.38-9.46c.24-.14.26-.35.05-.47l-5.36-3.1a.91.91,0,0,0-.82,0L232.25,305c-.24.14-.26.35-.05.47l5.36,3.1A.91.91,0,0,0,238.38,308.55Zm46.18-27.11a.89.89,0,0,0,.81,0l5.61-3.24c.24-.14.26-.35,0-.47l-5.37-3.1a.89.89,0,0,0-.81,0l-5.6,3.24c-.24.13-.26.35-.05.47ZM277.71,277l5.61-3.23c.24-.14.26-.35.05-.47l-5.37-3.1a.89.89,0,0,0-.81,0l-5.6,3.23c-.24.14-.27.35,0,.47l5.36,3.1A.89.89,0,0,0,277.71,277Zm-47.53,36.29,5.61-3.24c.24-.13.26-.34.05-.47l-5.37-3.09a.89.89,0,0,0-.81,0l-5.61,3.23c-.23.14-.26.35,0,.47l5.36,3.1A.89.89,0,0,0,230.18,313.28Zm36.27-21.38a.89.89,0,0,0,.81,0l5.61-3.23c.24-.14.26-.35.05-.47l-5.36-3.1a.91.91,0,0,0-.82,0l-5.6,3.23c-.24.14-.26.35-.05.47Zm-77.23,45,5.61-3.24c.23-.13.26-.34,0-.47l-5.37-3.09a.92.92,0,0,0-.81,0l-5.61,3.24c-.24.14-.26.35-.05.47l5.37,3.1A.89.89,0,0,0,189.22,336.93Zm8.19-4.73L203,329c.24-.13.26-.34,0-.47l-5.37-3.09a.89.89,0,0,0-.81,0l-5.6,3.23c-.24.14-.26.35,0,.47l5.36,3.1A.89.89,0,0,0,197.41,332.2ZM181,341.66l5.6-3.24c.24-.13.26-.34.05-.47l-5.36-3.09a.89.89,0,0,0-.81,0l-5.61,3.23c-.24.14-.26.35-.05.47l5.36,3.1A.91.91,0,0,0,181,341.66Zm32.77-18.92,5.6-3.24c.24-.13.26-.34,0-.47l-5.36-3.09a.91.91,0,0,0-.82,0l-5.6,3.23c-.24.14-.26.35,0,.47l5.36,3.1A.91.91,0,0,0,213.8,322.74Zm-8.19,4.73,5.6-3.24c.24-.13.26-.34,0-.47l-5.36-3.09a.91.91,0,0,0-.82,0l-5.6,3.23c-.24.14-.26.35,0,.47l5.36,3.1A.91.91,0,0,0,205.61,327.47ZM222,318l5.61-3.24c.23-.13.26-.34,0-.47l-5.36-3.09a.89.89,0,0,0-.81,0l-5.61,3.23c-.24.14-.26.35-.05.47l5.37,3.1A.89.89,0,0,0,222,318Zm44.71-65.8a.89.89,0,0,0,.81,0l5.61-3.23c.23-.14.26-.35,0-.47l-1.42-.83a.91.91,0,0,0-.82,0l-5.6,3.24c-.24.13-.26.34-.05.47ZM226,278a.89.89,0,0,0,.81,0l5.61-3.23c.24-.14.26-.35,0-.47l-5.37-3.1a.89.89,0,0,0-.81,0l-5.61,3.24c-.23.13-.26.34,0,.47Zm16.38-9.46a.91.91,0,0,0,.82,0l5.6-3.23c.24-.14.26-.35.05-.47l-5.36-3.1a.91.91,0,0,0-.82,0l-5.6,3.24c-.24.13-.26.34-.05.47ZM216,283.77a.91.91,0,0,0,.82,0l5.6-3.24c.24-.13.26-.34.05-.47l-5.36-3.09a.89.89,0,0,0-.81,0l-5.61,3.23c-.24.14-.26.35,0,.47Zm18.2-10.51a.91.91,0,0,0,.82,0l5.6-3.23c.24-.14.26-.35,0-.47l-5.36-3.1a.91.91,0,0,0-.82,0l-5.6,3.24c-.24.13-.26.34-.05.47Zm-34.58,20a.89.89,0,0,0,.81,0L206,290c.24-.13.26-.34.05-.47l-5.37-3.09a.89.89,0,0,0-.81,0l-5.61,3.23c-.23.14-.25.35,0,.47Zm8.19-4.73a.91.91,0,0,0,.82,0l5.6-3.24c.24-.13.26-.34.05-.47l-5.36-3.09a.91.91,0,0,0-.82,0l-5.6,3.23c-.24.14-.26.35-.05.47Zm42.53-26.83a.91.91,0,0,0,.82,0l5.6-3.23c.24-.14.26-.35,0-.47l-1.43-.83a.89.89,0,0,0-.81,0l-5.61,3.24c-.24.13-.26.34-.05.47Zm24.58-14.19a.89.89,0,0,0,.81,0l5.61-3.23c.24-.14.26-.35.05-.47l-1.43-.83a.89.89,0,0,0-.81,0l-5.61,3.24c-.24.13-.26.35-.05.47ZM286.15,254a.91.91,0,0,0,.82,0l5.6-3.24c.24-.14.26-.35.05-.47l-5.36-3.1a.93.93,0,0,0-.81,0l-5.61,3.24c-.24.14-.26.35,0,.47Zm15.61,18,5.6-3.24c.24-.14.26-.35.05-.47l-5.36-3.1a.89.89,0,0,0-.81,0l-5.61,3.24c-.24.14-.26.35-.05.47l5.36,3.09A.91.91,0,0,0,301.76,272Zm-43.26-15a.91.91,0,0,0,.82,0l5.6-3.23c.24-.14.26-.35.05-.47l-1.43-.83a.89.89,0,0,0-.81,0l-5.61,3.24c-.23.13-.25.34,0,.47Zm-67.1,41a.89.89,0,0,0,.81,0l5.61-3.24c.24-.13.26-.34,0-.47l-5.36-3.09a.89.89,0,0,0-.81,0l-5.61,3.24c-.24.14-.26.35-.05.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tuch-pad--inject-216"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "214.86 344.58 216.08 345.28 248.45 363.97 306.02 330.73 307.22 330.05 273.63 310.65 214.86 344.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.28 331.15 273.63 312.89 216.82 345.71 248.45 363.97 305.28 331.15",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.1,332.52c-2.33-1.08-3-2.93-3.19-6.21L41.44,173.16a10.57,10.57,0,0,1,4.93-9L241.18,51.67c2.95-1.7,5.11-2.62,7.83-.76s2.78,2.89,3,6.16l10.47,153.16a10.59,10.59,0,0,1-4.93,9L62.73,331.71C59.79,333.41,58.12,333.91,55.1,332.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,57.07c-.22-3.27-2.79-4.54-5.74-2.85L51.45,166.7a10.08,10.08,0,0,0-3.64,3.92l-5.09-2.56h0a10.27,10.27,0,0,1,3.66-3.92L241.18,51.67c2.95-1.7,5.12-2.64,7.83-.76C251.87,52.89,251.79,53.8,252,57.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.34,331.94c-2.68,1.58-4.38,1.78-7.24.58-2.18-.92-3-2.93-3.19-6.21L41.44,173.15a9.49,9.49,0,0,1,1.28-5.08l5.08,2.54h0a9.59,9.59,0,0,0-1.27,5.08L57,328.86C57.2,331.9,59.82,333.42,62.34,331.94Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.84,172.56,242.32,64.35c1.77-1,3.31-.26,3.44,1.7l9.77,142.88a6.37,6.37,0,0,1-3,5.41L65.09,322.55c-1.77,1-3.31.25-3.44-1.71L51.88,178A6.36,6.36,0,0,1,54.84,172.56Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.84,172.56a6.36,6.36,0,0,0-3,5.4l9.61,140.5,185.33-107a6.35,6.35,0,0,0,3-5.41l-9.6-140.5Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.79,50.64a1.28,1.28,0,0,0-.09-.35.08.08,0,0,0,0-.08,1.25,1.25,0,0,0-.12-.34,1.69,1.69,0,0,0-.27-.49,1.39,1.39,0,0,0-.15-.19.93.93,0,0,0-.14-.14,1.19,1.19,0,0,0-.29-.25l0,0a1.57,1.57,0,0,0-.37-.18,3.15,3.15,0,0,0-2.77.38L147.37,131c-2.2,1.27-3.86,4.3-3.57,8.59l8.06,117.63c-.12-1.82-.12-1.81-.12-1.8l.06.84a2.73,2.73,0,0,0,1.65,2.28l.18.11.23.11a1.48,1.48,0,0,0,.36.1,2,2,0,0,0,.54.05,2.69,2.69,0,0,0,1.35-.39l.1-.06h0l3.82-2.21,138.24-79.83a8,8,0,0,0,3.7-6.75L293.85,51.12A3.5,3.5,0,0,0,293.79,50.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.41,49.57a1.21,1.21,0,0,1,.5.1l.11,0h0l.06.05a.13.13,0,0,1,.06,0l.1.12h0v0l.1.12.07.11,0,0,.15.35v0l0,0,0,0a.58.58,0,0,1,0,.1c0,.12,0,.25,0,.38l8.13,118.57a6.84,6.84,0,0,1-3.13,5.68L159.46,255.28l-3.71,2.15h0l-.1.06-.1.06a1.74,1.74,0,0,1-.77.24h-.05l-.29,0-.12,0-.13-.06-.09-.05-.07,0,0,0,0,0a1.61,1.61,0,0,1-1-1.32l-.06-.84-.07-1.07h0l-7.87-114.76c-.28-4.11,1.37-6.58,3-7.52L290.12,50a2.64,2.64,0,0,1,1.29-.41m0-1.14a3.85,3.85,0,0,0-1.86.55L147.37,131c-2.2,1.27-3.86,4.3-3.57,8.59l8.06,117.63c-.12-1.68-.12-1.8-.12-1.8h0l.06.84a2.73,2.73,0,0,0,1.65,2.28l.18.11.23.11a1.48,1.48,0,0,0,.36.1,2.84,2.84,0,0,0,.5.06h.05a2.76,2.76,0,0,0,1.34-.39l.1-.06h0l3.82-2.21,138.24-79.83a8,8,0,0,0,3.7-6.75L293.85,51.12a3.5,3.5,0,0,0-.06-.48,1.28,1.28,0,0,0-.09-.35.08.08,0,0,0,0-.08,1.25,1.25,0,0,0-.12-.34,1.69,1.69,0,0,0-.27-.49,1.39,1.39,0,0,0-.15-.19.93.93,0,0,0-.14-.14,1.19,1.19,0,0,0-.29-.25l0,0a1.57,1.57,0,0,0-.37-.18,2.27,2.27,0,0,0-.91-.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.32,48.6a3.15,3.15,0,0,0-2.77.38L147.37,131a8,8,0,0,0-3.7,6.75l.51,7.46-5.49-2.77-.5-7.37a7.93,7.93,0,0,1,3.68-6.74l142.19-82a3,3,0,0,1,3-.29C287.83,46.43,291.4,48.19,292.32,48.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.84,51.09c-.18-2.43-2.09-3.37-4.29-2.1L147.37,131a7.94,7.94,0,0,0-3.69,6.75l.51,7.47L294.36,58.6Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.55,49,147.37,131a7.61,7.61,0,0,0-2.72,2.92l-5.47-2.72a7.49,7.49,0,0,1,2.7-2.87l142.18-82a3.12,3.12,0,0,1,3-.29c.77.41,4.34,2.15,5.24,2.57A3.15,3.15,0,0,0,289.55,49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.68,142.48l-.5-7.39a7.32,7.32,0,0,1,1-3.87l5.48,2.7a7.16,7.16,0,0,0-1,3.85l.51,7.47Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.44,60.5a3.63,3.63,0,0,0-1.55,3.15c.08,1.2.91,1.74,1.85,1.2a3.66,3.66,0,0,0,1.55-3.16C278.2,60.49,277.38,60,276.44,60.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.55,57A3.65,3.65,0,0,0,281,60.12c.08,1.2.91,1.74,1.85,1.2a3.64,3.64,0,0,0,1.54-3.16C284.31,57,283.49,56.42,282.55,57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.66,53.43a3.63,3.63,0,0,0-1.55,3.16c.08,1.2.91,1.74,1.85,1.19a3.62,3.62,0,0,0,1.54-3.15C290.42,53.42,289.6,52.89,288.66,53.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.45,258.58l-.23-.11-4.53-2.25a4.35,4.35,0,0,1-2.37-2.94,3.6,3.6,0,0,1-.08-.56l-7.56-110.25,5.5,2.77,7.61,111a2.65,2.65,0,0,0,1.44,2.15l.14.09,0,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.45,258.58l-.23-.11-4.53-2.25a4.35,4.35,0,0,1-2.37-2.94,3.6,3.6,0,0,1-.08-.56l-7.56-110.25,5.5,2.77,7.61,111a2.65,2.65,0,0,0,1.44,2.15l.14.09,0,0Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.45,136.19,212,116.64a8.28,8.28,0,0,1,7.9,2.15c2.08,2.07,3.35,5.33,3.62,9.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.45,136.19,212,116.64a8.28,8.28,0,0,1,7.9,2.15c2.08,2.07,3.35,5.33,3.62,9.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.37,135.14l-8-11.73a22.71,22.71,0,0,1,6.75-6.32,13.1,13.1,0,0,1,3.74-1.49Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.37,135.14l-8-11.73a22.71,22.71,0,0,1,6.75-6.32,13.1,13.1,0,0,1,3.74-1.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.37,137.62l-3.27,19.62c-5.88.85-10.22-3.81-10.75-11.53a31.64,31.64,0,0,1,6.05-19.77Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.37,137.62l-3.27,19.62c-5.88.85-10.22-3.81-10.75-11.53a31.64,31.64,0,0,1,6.05-19.77Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.42,137.4l14-8.1c.67,9.87-5.1,21.64-12.8,26.09a12.75,12.75,0,0,1-4.41,1.62Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.32,157l-25.09,14.48c-.68.39-1.28,0-1.34-.87h0A2.62,2.62,0,0,1,198,168.3l25.09-14.49c.68-.39,1.28,0,1.34.87h0A2.67,2.67,0,0,1,223.32,157Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.59 227.95 159.91 246.3 153.44 151.51 185.12 133.16 191.59 227.95",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "191.59 227.95 159.91 246.3 153.44 151.51 185.12 133.16 191.59 227.95",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M285.11,80.31l-51.88,30c-.68.39-1.28,0-1.34-.87h0a2.62,2.62,0,0,1,1.12-2.28l51.89-30c.68-.39,1.28,0,1.34.87h0A2.65,2.65,0,0,1,285.11,80.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.54,86.5l-51.89,30c-.68.4-1.28,0-1.34-.86h0a2.64,2.64,0,0,1,1.13-2.29l51.88-30c.68-.39,1.28,0,1.34.87h0A2.66,2.66,0,0,1,285.54,86.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.89 125.49 233.1 127.1 232.85 123.53 235.65 121.92 235.89 125.49",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "235.89 125.49 233.1 127.1 232.85 123.53 235.65 121.92 235.89 125.49",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "236.42 133.33 233.63 134.94 233.39 131.36 236.18 129.75 236.42 133.33",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "236.42 133.33 233.63 134.94 233.39 131.36 236.18 129.75 236.42 133.33",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "236.96 141.17 234.17 142.78 233.92 139.2 236.71 137.59 236.96 141.17",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.49 149 234.7 150.61 234.46 147.03 237.25 145.43 237.49 149",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "237.49 149 234.7 150.61 234.46 147.03 237.25 145.43 237.49 149",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M239.72,122.42a1,1,0,0,1-.5-1.87l47.1-27.19a1,1,0,0,1,1,1.74l-47.1,27.19A1,1,0,0,1,239.72,122.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.26,130.26a1,1,0,0,1-.5-1.87l47.09-27.19a1,1,0,0,1,1.37.37,1,1,0,0,1-.37,1.36l-47.09,27.19A1,1,0,0,1,240.26,130.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.79,138.09a1,1,0,0,1-.5-1.86L287.39,109a1,1,0,1,1,1,1.73L241.29,138A1,1,0,0,1,240.79,138.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.33,145.93a1,1,0,0,1-.5-1.87l47.09-27.19a1,1,0,0,1,1.37.37,1,1,0,0,1-.37,1.36l-47.09,27.2A1,1,0,0,1,241.33,145.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.77,189.73a1,1,0,0,1-.87-.5,1,1,0,0,1,.37-1.36L230,169.56a1,1,0,0,1,1,1.74l-31.7,18.3A1,1,0,0,1,198.77,189.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3,197.57a1,1,0,0,1-.5-1.87l31.7-18.3a1,1,0,1,1,1,1.73l-31.7,18.3A1,1,0,0,1,199.3,197.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.84,205.4a1,1,0,0,1-.5-1.86l31.7-18.3a1,1,0,0,1,1.36.36A1,1,0,0,1,232,187l-31.7,18.3A1,1,0,0,1,199.84,205.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.37,213.24a1,1,0,0,1-.5-1.87l31.7-18.3a1,1,0,0,1,1,1.74l-31.7,18.3A1,1,0,0,1,200.37,213.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.91,221.08a1,1,0,0,1-.5-1.87l31.69-18.3a1,1,0,0,1,1.37.37,1,1,0,0,1-.37,1.36l-31.69,18.3A1,1,0,0,1,200.91,221.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.37 184.78 243.14 188.95 241.07 158.57 248.3 154.4 250.37 184.78",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "250.37 184.78 243.14 188.95 241.07 158.57 248.3 154.4 250.37 184.78",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.19,192.38l-5.89,3.4c-.37.21-.69,0-.73-.47h0a1.42,1.42,0,0,1,.62-1.25l5.88-3.4c.37-.22.7,0,.73.47h0A1.44,1.44,0,0,1,250.19,192.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.62 178.86 253.39 183.03 251.32 152.66 258.55 148.48 260.62 178.86",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "260.62 178.86 253.39 183.03 251.32 152.66 258.55 148.48 260.62 178.86",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260.44,186.46l-5.88,3.4c-.37.21-.7,0-.73-.47h0a1.41,1.41,0,0,1,.61-1.25l5.88-3.4c.37-.22.7,0,.73.47h0A1.41,1.41,0,0,1,260.44,186.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.87 172.94 263.65 177.11 261.57 146.74 268.8 142.56 270.87 172.94",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.69,180.54l-5.88,3.4c-.37.21-.7,0-.73-.47h0a1.44,1.44,0,0,1,.61-1.25l5.89-3.4c.37-.21.69,0,.73.47h0A1.42,1.42,0,0,1,270.69,180.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.13 167.02 273.9 171.19 271.83 140.82 279.06 136.64 281.13 167.02",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "281.13 167.02 273.9 171.19 271.83 140.82 279.06 136.64 281.13 167.02",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281,174.62l-5.89,3.4c-.37.21-.69,0-.73-.47h0a1.42,1.42,0,0,1,.62-1.25l5.88-3.4c.37-.21.7,0,.73.47h0A1.44,1.44,0,0,1,281,174.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.38 161.1 284.15 165.27 282.08 134.9 289.31 130.72 291.38 161.1",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "291.38 161.1 284.15 165.27 282.08 134.9 289.31 130.72 291.38 161.1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.2,168.7l-5.88,3.4c-.37.21-.7,0-.73-.47h0a1.41,1.41,0,0,1,.61-1.25l5.88-3.4c.37-.21.7,0,.73.47h0A1.41,1.41,0,0,1,291.2,168.7Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.06,407.37l1.47.84,1.76,1,91.8,53.15c-.54-1.23-.11-3.68,1.14-6,1.46-2.74,3.7-4.91,5.31-5l-91.33-52.88-3.38-1.94C118,397.91,111.2,408.72,109.06,407.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.05,398.37l-3.27-1.87c-.93-.57-2.69,1.1-4.23,3.31-2.06,2.93-3.73,6.81-2.5,7.57l2.41,1.38.87.48c-1.23-.76.43-4.64,2.49-7.57,1.48-2.12,3.18-3.74,4.13-3.35h0A.18.18,0,0,1,119.05,398.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.23,397.91c-2.15-1.33-8.88,9.54-6.73,10.87l3.27,1.88c-2.16-1.33,4.57-12.2,6.73-10.87Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.61,401.59l-3.22-1.86c-2.11-1.33-8.71,9.1-6.92,10.76l.11.09,3.26,1.84C115.73,411.05,122.47,400.24,124.61,401.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.83,396.51v0l0,0c-.92-.59-2.68,1.09-4.23,3.31-2,2.87-3.7,6.67-2.55,7.52l-13.62-7.83A3.28,3.28,0,0,1,94.32,396c.76-4,5.4-9,8.34-7Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.24,462.88c-1.13,1.53-1,2.28-1,2.28l-14.12-2.78c-1.41-2.15-.49-5.62,1.45-8.1l.62.35Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.07,465.91l-3.85-.75s-.17-.75,1-2.28l3.35,2.12h0a.55.55,0,0,1,0,.77A.53.53,0,0,1,222.07,465.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.53,451.34h0l9.69,11a1.68,1.68,0,0,0-1,.54l-13.07-8.25-.62-.35A6.85,6.85,0,0,1,210.53,451.34Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.24,462.88a1.31,1.31,0,0,1,1-.54l2.35,2.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.55,454.28,95.69,392.64A9.83,9.83,0,0,0,94.32,396a3.27,3.27,0,0,0,1.06,3.55l13.68,7.87,1.47.84,1.76,1,91.8,53.15C202.37,459.72,204.26,455.79,205.55,454.28Z",
    style: {
      opacity: 0.2
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.14,391.92c-8-8.3-12.76-29.26-4.92-35.84h39.9c7.84,6.58,3.12,27.53-4.92,35.83l-.21.23-.28.27c-.23.22-.47.44-.73.65l-.19.16c-.2.15-.39.31-.61.46a10.76,10.76,0,0,1-1,.67c-6.61,3.86-17.33,3.86-23.94,0h0a10.88,10.88,0,0,1-1-.68c-.2-.14-.38-.28-.57-.43a2.11,2.11,0,0,1-.23-.19,8.62,8.62,0,0,1-.71-.63l-.31-.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.65,353.43c9.11,5.31,9.11,13.93,0,19.25s-23.86,5.31-33,0-9.11-13.94,0-19.25S60.55,348.11,69.65,353.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.27,356c6.69,3.91,6.69,10.24,0,14.14s-17.52,3.9-24.21,0-6.68-10.23,0-14.14S58.59,352.08,65.27,356Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.07,362.69c6.68-3.9,17.52-3.9,24.2,0a11.2,11.2,0,0,1,4,3.72,11.27,11.27,0,0,1-4,3.71c-6.68,3.9-17.52,3.9-24.2,0a11.27,11.27,0,0,1-4-3.71A11.2,11.2,0,0,1,41.07,362.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.71,324.34c-2.69,3.4-10.79,4.9-14.82-3.44-3.78-7.81-7.78-15.19-9-18.08a3.05,3.05,0,0,1,1.65-4.08s-.11-4.44,7.63-2,13.37,6.58,17.2,13.7S52.66,323,47.71,324.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.71,324.34c-2.69,3.4-10.79,4.9-14.82-3.44-3.78-7.81-7.78-15.19-9-18.08a3.05,3.05,0,0,1,1.65-4.08s-.11-4.44,7.63-2,13.37,6.58,17.2,13.7S52.66,323,47.71,324.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.82,335.45a39.36,39.36,0,0,0-1-4.43,62.81,62.81,0,0,0-3.15-8.46,63.52,63.52,0,0,0-9.92-15.38,55.18,55.18,0,0,0-7.42-7.24c-.09-.06-.13.12-.08.17a68.2,68.2,0,0,1,11.84,14,69.53,69.53,0,0,1,7.47,16.3c.49,1.6,1,3.22,1.39,4.84s.74,3.33,1.15,5c0,.17.3.25.3,0A31.88,31.88,0,0,0,51.82,335.45Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.82,335.45a39.36,39.36,0,0,0-1-4.43,62.81,62.81,0,0,0-3.15-8.46,63.52,63.52,0,0,0-9.92-15.38,55.18,55.18,0,0,0-7.42-7.24c-.09-.06-.13.12-.08.17a68.2,68.2,0,0,1,11.84,14,69.53,69.53,0,0,1,7.47,16.3c.49,1.6,1,3.22,1.39,4.84s.74,3.33,1.15,5c0,.17.3.25.3,0A31.88,31.88,0,0,0,51.82,335.45Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.48,318.37c-7,2.17-12.24-3.31-10.43-11.91s10.83-18.13,14.24-15.57c2.13-2.13,6.82-1.36,9,5.62S69.52,321.41,56.48,318.37Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.48,318.37c-7,2.17-12.24-3.31-10.43-11.91s10.83-18.13,14.24-15.57c2.13-2.13,6.82-1.36,9,5.62S69.52,321.41,56.48,318.37Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.6,296.12a94.1,94.1,0,0,0-4.67,15.44,149.85,149.85,0,0,0-2.71,16.17c-1.26,10.5-1.47,9.92-1.41,20.48,0,2.93.07,5.85.12,8.77s0,6.06.27,9c.1,1.15,1.73.84,1.75-.21.11-5.26-.18-10.55-.24-15.81a36,36,0,0,1,.1-4.41A219.24,219.24,0,0,1,56.65,314c.5-2.91,1.06-5.82,1.74-8.7s1.59-6,2.38-9C60.81,296.12,60.67,296,60.6,296.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6,296.12a94.1,94.1,0,0,0-4.67,15.44,149.85,149.85,0,0,0-2.71,16.17c-1.26,10.5-1.47,9.92-1.41,20.48,0,2.93.07,5.85.12,8.77s0,6.06.27,9c.1,1.15,1.73.84,1.75-.21.11-5.26-.18-10.55-.24-15.81a36,36,0,0,1,.1-4.41A219.24,219.24,0,0,1,56.65,314c.5-2.91,1.06-5.82,1.74-8.7s1.59-6,2.38-9C60.81,296.12,60.67,296,60.6,296.12Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.23,341.59c-.9,4.55-7.12,7.83-14.32,4.85S4.53,324.77,11,322.7c-.35-3.39,19.24-6.18,28.94,5.77C47,337.16,40.23,341.59,40.23,341.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.23,341.59c-.9,4.55-7.12,7.83-14.32,4.85S4.53,324.77,11,322.7c-.35-3.39,19.24-6.18,28.94,5.77C47,337.16,40.23,341.59,40.23,341.59Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.52,348.34a33,33,0,0,0-2.93-3.21,88.05,88.05,0,0,0-6.6-5.91,89.19,89.19,0,0,0-15.18-9.76,78.63,78.63,0,0,0-9.16-4.16c-.08,0,0,.13,0,.16,2.62,1.24,5.24,2.44,7.77,3.85A87.2,87.2,0,0,1,32,334.12a110.83,110.83,0,0,1,13.4,11c1.18,1.14,2.31,2.33,3.5,3.46s2.58,2.24,3.76,3.46c.18.18.49.1.3-.16C52.16,350.69,51.4,349.48,50.52,348.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.52,348.34a33,33,0,0,0-2.93-3.21,88.05,88.05,0,0,0-6.6-5.91,89.19,89.19,0,0,0-15.18-9.76,78.63,78.63,0,0,0-9.16-4.16c-.08,0,0,.13,0,.16,2.62,1.24,5.24,2.44,7.77,3.85A87.2,87.2,0,0,1,32,334.12a110.83,110.83,0,0,1,13.4,11c1.18,1.14,2.31,2.33,3.5,3.46s2.58,2.24,3.76,3.46c.18.18.49.1.3-.16C52.16,350.69,51.4,349.48,50.52,348.34Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.05,336.11c-.12-2.56-13-2.42-19.06,2.44s-6.76,9.63-3,11.29c-.66,5.4,7.87,9,15.51,2.2S82.81,336.65,80.05,336.11Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.05,336.11c-.12-2.56-13-2.42-19.06,2.44s-6.76,9.63-3,11.29c-.66,5.4,7.87,9,15.51,2.2S82.81,336.65,80.05,336.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.35,342.88A31.74,31.74,0,0,0,53.1,355.4c-.19.31.3.92.51.58a36.93,36.93,0,0,1,13.74-13S67.4,342.85,67.35,342.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.35,342.88A31.74,31.74,0,0,0,53.1,355.4c-.19.31.3.92.51.58a36.93,36.93,0,0,1,13.74-13S67.4,342.85,67.35,342.88Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.77,358.15c-4.37,4.29.46,9.6,7.54,12.23a25.38,25.38,0,0,0,18.34-.85c3.41-1.7,4.12-2.56,4.12-2.56a43.21,43.21,0,0,0-3.62-8.67,18.15,18.15,0,0,0-17.86-8.21C58.22,351.25,57.48,355,58.77,358.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.77,358.15c-4.37,4.29.46,9.6,7.54,12.23a25.38,25.38,0,0,0,18.34-.85c3.41-1.7,4.12-2.56,4.12-2.56a43.21,43.21,0,0,0-3.62-8.67,18.15,18.15,0,0,0-17.86-8.21C58.22,351.25,57.48,355,58.77,358.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.1,361.37A46.05,46.05,0,0,0,66,357.26c-3.8-.73-8.47-.77-11.55,1.94-1.19,1.05-2.78,3.32-1.81,4.93.1.16.58.46.69.14a15.27,15.27,0,0,1,1-3,6.1,6.1,0,0,1,2.38-2.24,14.09,14.09,0,0,1,8-1.36c4.33.41,8.39,2.15,12.37,3.78C77.14,361.49,77.14,361.38,77.1,361.37Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1,361.37A46.05,46.05,0,0,0,66,357.26c-3.8-.73-8.47-.77-11.55,1.94-1.19,1.05-2.78,3.32-1.81,4.93.1.16.58.46.69.14a15.27,15.27,0,0,1,1-3,6.1,6.1,0,0,1,2.38-2.24,14.09,14.09,0,0,1,8-1.36c4.33.41,8.39,2.15,12.37,3.78C77.14,361.49,77.14,361.38,77.1,361.37Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,331.11c-1.09,3.84,3.8,7.42,9.9,5.37s12.42-4,17.61-4S96,329,94.9,326.67s-2.33-7.77-15.56-9.33-19.21,3.11-22,6.76S57.76,331.76,60,331.11Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,331.11c-1.09,3.84,3.8,7.42,9.9,5.37s12.42-4,17.61-4S96,329,94.9,326.67s-2.33-7.77-15.56-9.33-19.21,3.11-22,6.76S57.76,331.76,60,331.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.56,323.05a16.58,16.58,0,0,0-4.27-.39,25.86,25.86,0,0,0-4.13.34,31.78,31.78,0,0,0-7.78,2.42c-4.65,2.06-9.26,4.75-12.28,8.94a29.76,29.76,0,0,0-3.9,7.29c-.17.49.78.77,1,.33a53.74,53.74,0,0,1,3.31-6.34,19.6,19.6,0,0,1,5.07-5.28,40.33,40.33,0,0,1,14-6.43,28.31,28.31,0,0,1,4.48-.66,42.21,42.21,0,0,1,4.5.17C84.79,323.45,84.7,323.09,84.56,323.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.56,323.05a16.58,16.58,0,0,0-4.27-.39,25.86,25.86,0,0,0-4.13.34,31.78,31.78,0,0,0-7.78,2.42c-4.65,2.06-9.26,4.75-12.28,8.94a29.76,29.76,0,0,0-3.9,7.29c-.17.49.78.77,1,.33a53.74,53.74,0,0,1,3.31-6.34,19.6,19.6,0,0,1,5.07-5.28,40.33,40.33,0,0,1,14-6.43,28.31,28.31,0,0,1,4.48-.66,42.21,42.21,0,0,1,4.5.17C84.79,323.45,84.7,323.09,84.56,323.05Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.12,352.74c-1-3.94-6-6.16-12.57-6.64a17.1,17.1,0,0,0-16.27,8.34c-3.42,5.85-4.84,10.5-2.76,11.27s10.86,2,16.53,2.48,12.76-.51,17.38-4.82S54.53,353.65,49.12,352.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.12,352.74c-1-3.94-6-6.16-12.57-6.64a17.1,17.1,0,0,0-16.27,8.34c-3.42,5.85-4.84,10.5-2.76,11.27s10.86,2,16.53,2.48,12.76-.51,17.38-4.82S54.53,353.65,49.12,352.74Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.36,352.22a17.31,17.31,0,0,0-7.06-.33,31.72,31.72,0,0,0-6.66,1.54,42.53,42.53,0,0,0-6.6,3c-1.11.6-2.2,1.25-3.26,1.93a23.79,23.79,0,0,0-2.93,2s0,.16,0,.13C24,360,25,359.33,26,358.75s2.22-1.23,3.35-1.81a47.49,47.49,0,0,1,6.54-2.77,31.13,31.13,0,0,1,6.94-1.49,43,43,0,0,1,6.62.17C49.89,352.88,49.64,352.31,49.36,352.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.36,352.22a17.31,17.31,0,0,0-7.06-.33,31.72,31.72,0,0,0-6.66,1.54,42.53,42.53,0,0,0-6.6,3c-1.11.6-2.2,1.25-3.26,1.93a23.79,23.79,0,0,0-2.93,2s0,.16,0,.13C24,360,25,359.33,26,358.75s2.22-1.23,3.35-1.81a47.49,47.49,0,0,1,6.54-2.77,31.13,31.13,0,0,1,6.94-1.49,43,43,0,0,1,6.62.17C49.89,352.88,49.64,352.31,49.36,352.22Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-3--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.09,198.33a19.85,19.85,0,0,1-12.44,7.6l-2.25.25A19.83,19.83,0,0,1,453.88,167l2.25-.37a19.83,19.83,0,0,1,18,31.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.19,169.19a21.52,21.52,0,0,0-28.58,32l-1.82,6.44a1.25,1.25,0,0,0,1.86,1.4l5.68-3.53a21.52,21.52,0,0,0,22.86-36.3Zm2.9,29.14a19.85,19.85,0,0,1-12.44,7.6l-2.25.25A19.83,19.83,0,0,1,453.88,167l2.25-.37a19.83,19.83,0,0,1,18,31.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.09,198.33a19.85,19.85,0,0,1-12.44,7.6l-2.25.25A19.83,19.83,0,0,1,453.88,167l2.25-.37a19.83,19.83,0,0,1,18,31.66Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M444,186.41a3.21,3.21,0,0,1,.24-1.23,3,3,0,0,1,.65-1,3.29,3.29,0,0,1,2.24-.92,3.23,3.23,0,0,1,1.24.25,3.43,3.43,0,0,1,1,.66,3.06,3.06,0,0,1,.68,1,3,3,0,0,1,.25,1.22,3,3,0,0,1-.92,2.23,3.21,3.21,0,0,1-1,.65,3.15,3.15,0,0,1-1.24.24,3.22,3.22,0,0,1-1.24-.23,3.14,3.14,0,0,1-1-.65,3.07,3.07,0,0,1-.66-1A3.14,3.14,0,0,1,444,186.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.09,186.41a3.21,3.21,0,0,1,.24-1.23,3,3,0,0,1,.65-1,3.19,3.19,0,0,1,3.48-.67,3.62,3.62,0,0,1,1,.66,3.19,3.19,0,0,1,.67,1,3,3,0,0,1,.25,1.22,3.15,3.15,0,0,1-.24,1.24,3.26,3.26,0,0,1-.67,1,3.38,3.38,0,0,1-1,.65,3.15,3.15,0,0,1-1.24.24,3.22,3.22,0,0,1-1.24-.23,3.14,3.14,0,0,1-1-.65,3.07,3.07,0,0,1-.66-1A3.14,3.14,0,0,1,455.09,186.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.17,186.41a3.21,3.21,0,0,1,.24-1.23,3,3,0,0,1,.65-1,3.19,3.19,0,0,1,3.48-.67,3.62,3.62,0,0,1,1,.66,3,3,0,0,1,.67,1,3.21,3.21,0,0,1,0,2.46,3.26,3.26,0,0,1-.67,1,3.38,3.38,0,0,1-1,.65,3.14,3.14,0,0,1-1.23.24,3.23,3.23,0,0,1-1.25-.23,3.14,3.14,0,0,1-1-.65,2.89,2.89,0,0,1-.65-1A3.14,3.14,0,0,1,466.17,186.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.16,67.53A19.84,19.84,0,0,1,343.73,67l2.09.88a19.83,19.83,0,0,1-14.33,36.84l-2.14-.78a19.82,19.82,0,0,1-.19-36.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.44,94.36A21.53,21.53,0,0,0,358,80.43l4.73-4.72a1.25,1.25,0,0,0-.93-2.14l-6.69.3a21.53,21.53,0,0,0-37.69,20.49Zm11.72-26.83A19.84,19.84,0,0,1,343.73,67l2.09.88a19.83,19.83,0,0,1-14.33,36.84l-2.14-.78a19.82,19.82,0,0,1-.19-36.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16,67.53A19.84,19.84,0,0,1,343.73,67l2.09.88a19.83,19.83,0,0,1-14.33,36.84l-2.14-.78a19.82,19.82,0,0,1-.19-36.39Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.15,74.57a13.3,13.3,0,0,1,1.54-1.18,10.92,10.92,0,0,1,1.82-1,10.49,10.49,0,0,1,2.12-.65,12,12,0,0,1,2.47-.24,10.1,10.1,0,0,1,3.29.5,7.22,7.22,0,0,1,2.54,1.42,6.16,6.16,0,0,1,1.64,2.23,7.1,7.1,0,0,1,.58,2.93,7.51,7.51,0,0,1-.45,2.73,8,8,0,0,1-1.14,2,8.37,8.37,0,0,1-1.51,1.47L340.5,86a10.7,10.7,0,0,0-1.25,1.08,2.1,2.1,0,0,0-.64,1.19l-.47,3h-3.51l-.35-3.38a2.69,2.69,0,0,1,.28-1.71,4.94,4.94,0,0,1,1.08-1.35,13.31,13.31,0,0,1,1.5-1.19,14.38,14.38,0,0,0,1.56-1.24,6.53,6.53,0,0,0,1.21-1.52,3.88,3.88,0,0,0,.49-2,3,3,0,0,0-1.06-2.36,3.5,3.5,0,0,0-1.19-.65,4.64,4.64,0,0,0-1.51-.23,6.64,6.64,0,0,0-3.39.84c-.38.21-.7.41-1,.58a1.35,1.35,0,0,1-.7.26,1.14,1.14,0,0,1-1.08-.62Zm3.92,22.18a3.2,3.2,0,0,1,.24-1.22A2.93,2.93,0,0,1,335,93.87a3.07,3.07,0,0,1,1.25-.25,3,3,0,0,1,1.23.25,3.41,3.41,0,0,1,1,.66,3.17,3.17,0,0,1,.92,2.22,3,3,0,0,1-.25,1.24,3.09,3.09,0,0,1-.67,1,3.38,3.38,0,0,1-1,.65,3.14,3.14,0,0,1-1.23.24,3.24,3.24,0,0,1-1.25-.24,3.14,3.14,0,0,1-1-.65,3.21,3.21,0,0,1-.65-1A3.15,3.15,0,0,1,333.07,96.75Z",
    style: {
      fill: "#BA68C8"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.37,124.34c0-15.88-18-28.75-40.12-28.75s-40.13,12.87-40.13,28.75,18,28.75,40.13,28.75c1.33,0,2.65-.05,4-.14,4.38,8.23,11.83,9.65,17.63,9a10.86,10.86,0,0,1-6.19-11.05C92.16,146.57,102.37,136.31,102.37,124.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.39,162.5A16.75,16.75,0,0,1,66,153.38c-1.25.08-2.5.12-3.71.12-22.36,0-40.55-13.08-40.55-29.16S39.89,95.18,62.25,95.18s40.54,13.08,40.54,29.16c0,11.77-9.71,22.3-24.76,26.87a10.47,10.47,0,0,0,6,10.35.42.42,0,0,1-.13.8A22.8,22.8,0,0,1,81.39,162.5Zm-15.19-10a.42.42,0,0,1,.37.22c4.22,7.93,11.22,9.1,15.81,8.89a11.4,11.4,0,0,1-5.16-10.79.42.42,0,0,1,.3-.36C92.36,146.07,102,135.81,102,124.34,102,108.72,84.14,96,62.25,96s-39.71,12.71-39.71,28.33,17.81,28.33,39.71,28.33c1.28,0,2.6,0,3.92-.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.83,125.16a4.08,4.08,0,1,1-4.08-4.09A4.08,4.08,0,0,1,48.83,125.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.33,125.16a4.08,4.08,0,1,1-4.08-4.09A4.08,4.08,0,0,1,66.33,125.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.83,125.16a4.09,4.09,0,1,1-4.08-4.09A4.08,4.08,0,0,1,83.83,125.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.83,125.16a4.08,4.08,0,1,1-4.08-4.09A4.08,4.08,0,0,1,48.83,125.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.33,125.16a4.08,4.08,0,1,1-4.08-4.09A4.08,4.08,0,0,1,66.33,125.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.83,125.16a4.09,4.09,0,1,1-4.08-4.09A4.08,4.08,0,0,1,83.83,125.16Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.92,218.07l7.83-45.19,5-.25-10.3,45.44h0a.7.7,0,0,1-.33.44,1.94,1.94,0,0,1-1.77.09.61.61,0,0,1-.39-.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.62,165.45h5l11.67,47h0a.59.59,0,0,1-.36.54,1.91,1.91,0,0,1-1.77,0,.68.68,0,0,1-.35-.42h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.29,239.61l.22-50.62,5-.25-2.68,50.86h0a.66.66,0,0,1-.33.45,2,2,0,0,1-1.76.09.59.59,0,0,1-.39-.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.53,149.7h5l7.94,49.88h0a.63.63,0,0,1-.36.55,2,2,0,0,1-1.77,0,.69.69,0,0,1-.36-.43h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.91,110.63a28.09,28.09,0,0,1,2,8.72c.57,6.68-1.69,28.31-3.05,38h0c-2,16.16-4.37,16.19-7.87,18.9-6,4.65-23.35,13.77-29.07,16-10.37,4.08-18.84-2.21-25.16-5.33A145.63,145.63,0,0,1,343,177c-1.58-1.15-2.4-2.32-2.38-3.54,0-.48,0-2.47,0-3,0-1.56,1.38-3.23,4.28-5.11,5.35-3.48,24.71-14.77,32.21-18.92a.06.06,0,0,1,.06-.06c5.77-3.51,9.24-27.32,13.24-40,.09-.27.17-.53.26-.78s.14-.4.21-.59c.25-.69.51-1.32.78-1.9",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.61,170.48c0-1.56,1.38-3.23,4.28-5.11,5.35-3.48,24.71-14.77,32.21-18.92a.06.06,0,0,1,.06-.06c5.77-3.51,9.24-27.32,13.24-40a24.67,24.67,0,0,1,.84-2.33c0-.06.05-.11.07-.17s.15-.34.23-.51.07-.18.11-.26h0a12,12,0,0,1,2.67-3.85,5.3,5.3,0,0,1,1.3-.92L398,97c3.92-2.34,9.06.47,15.46,4,4,2.19,7.39,4.78,9.46,9.62h0a28.09,28.09,0,0,1,2,8.72c.57,6.68-1.69,28.31-3.05,38h0c-2,16.16-4.37,16.19-7.87,18.9-6,4.65-23.35,13.77-29.07,16-10.37,4.08-18.84-2.21-25.16-5.33A145.63,145.63,0,0,1,343,177c-1.58-1.15-2.4-2.32-2.38-3.54C340.62,173,340.61,171,340.61,170.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.61,170.48c0-1.56,1.38-3.23,4.28-5.11,5.35-3.48,24.71-14.77,32.21-18.92a.06.06,0,0,1,.06-.06c5.77-3.51,9.24-27.32,13.24-40a24.67,24.67,0,0,1,.84-2.33c0-.06.05-.11.07-.17s.15-.34.23-.51.07-.18.11-.26h0a12,12,0,0,1,2.67-3.85,5.3,5.3,0,0,1,1.3-.92L398,97c3.92-2.34,9.06.47,15.46,4,4,2.19,7.39,4.78,9.46,9.62h0a28.09,28.09,0,0,1,2,8.72c.57,6.68-1.69,28.31-3.05,38h0c-2,16.16-4.37,16.19-7.87,18.9-6,4.65-23.35,13.77-29.07,16-10.37,4.08-18.84-2.21-25.16-5.33A145.63,145.63,0,0,1,343,177c-1.58-1.15-2.4-2.32-2.38-3.54C340.62,173,340.61,171,340.61,170.48Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.74,183.91A146.9,146.9,0,0,1,343,174c-3.59-2.61-3.26-5.28,1.89-8.62,7.15-4.64,36.33-21.2,36.33-21.2S418.1,165.94,416.51,170s-24.42,16.45-31.61,19.28C374.53,193.32,366.06,187,359.74,183.91Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.74,183.91A146.9,146.9,0,0,1,343,174c-3.59-2.61-3.26-5.28,1.89-8.62,7.15-4.64,36.33-21.2,36.33-21.2S418.1,165.94,416.51,170s-24.42,16.45-31.61,19.28C374.53,193.32,366.06,187,359.74,183.91Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M395.63,98.36c3.88-2,8.93.73,15.17,4.15,4,2.19,7.4,4.79,9.47,9.65l2.64-1.53c-2.07-4.84-5.47-7.43-9.46-9.62-6.4-3.51-11.54-6.32-15.46-4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.63,98.36c3.88-2,8.93.73,15.17,4.15,4,2.19,7.4,4.79,9.47,9.65l2.64-1.53c-2.07-4.84-5.47-7.43-9.46-9.62-6.4-3.51-11.54-6.32-15.46-4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.16,146.39s3.76,1.23,17.18,7.82c5.5,2.7,9.13,5.43,14.28,8.68,7.59,4.77,7,8.32,7,8.32,3.77-3.13,7.53-39.39,6.6-50.37a27.52,27.52,0,0,0-2.16-9.13l-.31-.64-.22-.43-.12-.2a14.6,14.6,0,0,0-.95-1.53l-.25-.35-.27-.35-.27-.34-.23-.27a16.49,16.49,0,0,0-1.36-1.41q-.18-.18-.36-.33a22.35,22.35,0,0,0-2.4-1.83l-.39-.25-.53-.33-.44-.26c-.39-.23-.78-.46-1.18-.68C406,99.9,402,97.66,398.57,97.66a6.29,6.29,0,0,0-4.24,1.62c-2.51,2.2-3.84,6.85-3.93,7.12C386.4,119.07,382.93,142.88,377.16,146.39Z",
    style: {
      fill: "#BA68C8"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.57,196.35s4.81,10.29,5.4,14.42c.61,4.3,1.8,5.64,1.46,10.4-.07,1-.44,3.13-.5,4a1.24,1.24,0,0,0,1.26,1.44c1.95.24,4.82-3.53,6-7.48a112,112,0,0,0,2.61-13.79,5.91,5.91,0,0,0-.87-3,9.23,9.23,0,0,0-1-1.49c-.8-1.83-1.42-5.38-2.17-7.81Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.87,209a4.46,4.46,0,0,1,.64,1.37c.12.86-1.62,3.85-2.3,5a6.8,6.8,0,0,0-1,5,11.67,11.67,0,0,1-2.27,7.91,19.2,19.2,0,0,1-9.07,6.92c-4.52,1.76-6.36-.39-6.36-.39s-1.63-2.09-.84-3S370.87,209,370.87,209Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.9,200.84c.14,0,.39-.08.79.32.15.15,1.18,2.13,2,3.15s2.82,2.91,3.21,4.64c-.78,3.45-3.8,6.05-4,9.27s.06,6.92-4.59,11.21-9.75,5.09-11.69,4.2-1.94-2.84.31-6.73c2.39-4.12,3.48-12.75,3.48-12.75a26.24,26.24,0,0,0,.17-3.65,23,23,0,0,0-.66-3.54,2.69,2.69,0,0,1,.09-1.64,2.84,2.84,0,0,1,1.29-1,12.9,12.9,0,0,1,2.49-1.05,4.24,4.24,0,0,1,2.68.11,16.86,16.86,0,0,0,1.74.9,2.36,2.36,0,0,0,2.41-.62,1.94,1.94,0,0,0,.47-2.26A4,4,0,0,0,364.9,200.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.92,226.08a8.09,8.09,0,0,0-7.57-3.27c-5.3.43-6.91,3.22-7.58,4.84-.79,1.92-1.5,5.36.77,6.15,2.46.85,5.17.32,9.29-2.13S364.92,226.08,364.92,226.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.58,210.51a.54.54,0,0,1-.48,0c-.86-.34-5.27-.89-7.59,1.6-.35-.23-.32-.71,0-1.4,2.79-2.07,7-1.57,8-1.15a.49.49,0,0,1,.27.67A.56.56,0,0,1,362.58,210.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.23,215.21a1.58,1.58,0,0,1,.18-1.45,10.11,10.11,0,0,1,7.65-.9.48.48,0,0,1,.26.67.6.6,0,0,1-.22.25.56.56,0,0,1-.49,0C360.78,213.48,356.6,213,354.23,215.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.68,222.4a2.9,2.9,0,0,1,.52-1.94,10,10,0,0,1,7.88-1.06.49.49,0,0,1,.27.67.56.56,0,0,1-.23.25.54.54,0,0,1-.48,0C359.73,220,354.87,219.4,352.68,222.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.61,217.05a.56.56,0,0,1-.49,0c-.84-.34-5.16-.87-7.5,1.52a1.78,1.78,0,0,1,.3-1.57,10.11,10.11,0,0,1,7.65-.9.49.49,0,0,1,.27.67A.56.56,0,0,1,361.61,217.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.19,206.59s-.94,10.72-2.17,18.22c-.89,5.45-5.3,7.5-9.1,10.75-.83.71-2.68,2-3.35,2.56a1.27,1.27,0,0,0-.14,2c1.28,1.59,7.45,2.83,11.29.78s7.75-7,10.11-8.81c.89-.66,1.73-1.35,2.54-2.08s.71-1.51.89-2.41c.09-.44.61-2.63.61-2.63.77-2.08,2.76-7.41,3.65-9.81Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.78,235.18a4.53,4.53,0,0,1-.31,1.51c-.42.78-3.69,2.22-4.93,2.72a7.06,7.06,0,0,0-3.89,3.55,12.27,12.27,0,0,1-6.72,5.19,20.15,20.15,0,0,1-11.77.35c-4.84-1.22-4.59-4.08-4.59-4.08s0-2.7,1.22-3S359.78,235.18,359.78,235.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.87,225c.13.07.23.17.32.74,0,.21-.31,2.45-.27,3.76s.58,4.07-.14,5.73c-2.76,2.39-6.86,2.75-9,5.29s-4.16,5.75-10.65,6.53-10.76-1.14-11.83-3,.71-3.51,4.25-5.66c4.21-2.55,10.29-8.59,10.3-8.6.52-.55,1-1.13,1.48-1.73a6.93,6.93,0,0,0,1.28-3.89c0-.62.16-1.16.83-1.38a2.72,2.72,0,0,1,1-.1,14.29,14.29,0,0,1,4.43.87,15,15,0,0,1,2,.94c.51.29,1.26.61,1.51,1.17a1.45,1.45,0,0,1,0,.8,16,16,0,0,1-.57,2.56.53.53,0,0,0,0,.37c.2.42,1.63-1.29,1.82-1.5a3.4,3.4,0,0,1,1.57-1,1.69,1.69,0,0,0,1.27-1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.39,245.8a8.1,8.1,0,0,0-4.33-7.17c-4.69-2.78-6.82-1.07-8.36-.13-1.84,1.12-5,3.43-3.62,5.42,1.53,2.16,3.73,3.07,8.65,3.48S344.39,245.8,344.39,245.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.91,231.57a.56.56,0,0,1-.42-.26c-.51-.79-3.85-3.85-7.31-3.17-.15-.4.16-.77.89-1.13,3.58-.06,6.76,2.82,7.37,3.77a.51.51,0,0,1-.19.72A.58.58,0,0,1,351.91,231.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.08,230.51a1.65,1.65,0,0,1,1-1.09A10.33,10.33,0,0,1,350,233.2a.49.49,0,0,1-.19.71.55.55,0,0,1-.33.07.56.56,0,0,1-.43-.26C348.6,233,345.42,230.05,342.08,230.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.42,235.53a3,3,0,0,1,1.6-1.29,10.24,10.24,0,0,1,7.23,3.78.5.5,0,0,1-.19.71.58.58,0,0,1-.34.07.56.56,0,0,1-.42-.26C343.77,237.71,340.07,234.35,336.42,235.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.12,236.39a.6.6,0,0,1-.43-.26c-.49-.78-3.77-3.77-7.18-3.18a1.82,1.82,0,0,1,1.21-1.12,10.4,10.4,0,0,1,6.93,3.78.5.5,0,0,1-.19.71A.6.6,0,0,1,347.12,236.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.81,139.43s-20.1,10.8-29.63,20.72c-3.42,3.56-5.54,6.67-1.93,15.83,2.78,7.06,7,16.6,11.47,25.73L395.35,150Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.72,201.71l27-43.08-.94-.14c-5.1-2.22-7.21-9.12-7.21-9.12a11.83,11.83,0,0,0,2.24,8.79c-2.87,2.12-9.36,6.92-19.33,14.44-1.74,1.31-5,3.79-5,8.65,0,6.89.29,14.34.29,14.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.78,139.43h0l41.7,6.13c0,5-1.4,13.31-5.16,19-2.72,4.09-5.74,6.59-16.37,12.22-9.9,5.24-18.76,9.62-21,10.84-1.71.93-1.67,5.51-2.55,10-1.79,9-7.22,22.57-7.22,22.57A18.33,18.33,0,0,1,348,216.7s1.65-20.28,2.46-27c1-8,.92-10,4.89-13.92,3.4-3.34,23.49-17.33,23.49-17.33S369.24,148.76,372.78,139.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,144.75c-.21,6.86-1.14,12.07-6.06,17.13-3.15-2.11-2.51-4.08-1.35-7.61.35-1.06.75-2.27,1.08-3.62a35.3,35.3,0,0,0,1.06-6.67l-.16,0-.42-.06a34.82,34.82,0,0,1-1,6.62c-.33,1.34-.72,2.53-1.07,3.58-1.16,3.52-1.92,5.87,1.49,8.21a34.54,34.54,0,0,1-4,3.32c-7.36,5.27-17.74,11.47-23.95,15.18-2.17,1.29-3.88,2.31-4.76,2.88-3.6,2.3-3.9,4.29-4,10.34-.08,7.58-4.55,18.77-6.74,26.37l.59,0c2.24-7.73,6.83-19.07,6.73-26.36-.09-6.13.45-7.77,3.69-9.84.87-.56,2.58-1.58,4.75-2.88,6.21-3.7,16.61-9.91,24-15.2,9-6.48,10.44-12.56,10.71-21.25Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.65,131.69c3,1.08,8.25-.49,11.92-4.09s15.75-16.77,15.75-16.77l1.48-21.15a11.3,11.3,0,0,0-8.16,2.22c-3.47,2.93-13.64,18.28-16.44,22.52S354.65,131.69,354.65,131.69Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.09,89.66c-4-.51-7.24-.94-12.15,5.59-4.45,5.93-10.26,14.89-10.26,14.89a13.55,13.55,0,0,0,3.13,8.31c3.35,4.21,6.22,5.13,6.22,5.13l11.62-12.34Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M409.29,95.71c2.28,1.18,5.69,5.64,6.55,15.33.52,5.93,1.12,6.86-.35,24.56-.57,6.86-.53,11-2.12,20-8.32,2.83-37.7-.41-44.14-14.45,1.75-3.11,1.95-9.52,2-13.51s.33-17.36.65-21.08c1-11.83,6.14-16.45,12.18-16.9,0,0,7.32,1,12.08,1.84a69,69,0,0,1,13.12,4.21",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.29,95.71c5.4,3.53,6.24,11.55,6.85,17.45a65.38,65.38,0,0,1,.24,11.62c-.76,10.34-1.06,20.73-2.85,31-8,2.08-16.59.67-24.5-1.21-7.72-2.16-16.27-5.66-20-13.3,1.91-4.36,1.93-9.49,2.06-14.26s.21-9.62.37-14.43c0-8.84,1.54-22.15,12.65-23,8.6,1.1,17.25,2.48,25.18,6.17a68.84,68.84,0,0,0-12.36-4c-3.69-.77-9.07-1.37-12.85-1.94-10.85.91-12.31,14-12.29,22.78-.14,4.81-.24,9.62-.33,14.43s.05,9.81-2,14.27v-.19c1.71,3.69,4.93,6.46,8.42,8.5,9.26,5.31,25,8.47,35.47,5.88,1.42-9.33,2.17-20.64,2.82-30.67a68,68,0,0,0-.17-11.59c-.56-5.92-1.31-13.86-6.67-17.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.4,86.51c.49-3.32,3.7-6.86,5.11-9.78s2.16-5,1.94-7.61c-.14-1.55-1.16-3.63-2.32-4a7.2,7.2,0,0,0-5.51-8.85,25,25,0,0,1-3.2-.81c-1.26-.49-1.56-1.49-2.59-2.32-1.77-1.43-4.69-1.39-5.75.86-1.18-1.46-2.75-1.38-4.54-.88a3.07,3.07,0,0,0-2.28,3.54,3.25,3.25,0,0,0-4.82,1.9c-.13,1,.11,1.93-.55,2.88s-2.21,1.1-2.67.25c-.22,1.5.39,2.62,2,2.5a3.42,3.42,0,0,0-.35,2.85,3.11,3.11,0,0,0,2.84,2.06A4.75,4.75,0,0,0,378.43,73a33.67,33.67,0,0,0,7.83,1.9l3.14.57c.18,0,1.13.07,1.24.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.31,82.13a3.21,3.21,0,0,1-3.91,0L398.84,93c-1.71,4.72-9.67,5.7-12.61,4.44s-2.61-3-.79-5.64l-.24-1.78a31.85,31.85,0,0,1-3.94-.08c-2.61-.3-4.61-2.35-5.42-5.15a29.17,29.17,0,0,1-.59-11.13,9.6,9.6,0,0,0,.07-2.73,13,13,0,0,1,.67-5.87c2.8-2.37,9.39-3.31,15.64.28-.62,3.69.87,6.56,3.57,7.89-.1,1-.16,3.5,1.47,3.41,1.17-.06,1.21-1.53,2.38-2.86s4-1.74,5.11.14A6.34,6.34,0,0,1,402.31,82.13Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.7,71.42l7.85,2a3.16,3.16,0,0,0-1.1,1.28l-6.84-1.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.06,70.41a2.17,2.17,0,0,0,.33,1.19.88.88,0,0,1,.14.43,21.28,21.28,0,0,0,.27,3.21,3.14,3.14,0,0,0,2.95,2.54,4.58,4.58,0,0,0,1.12,0H378a3.42,3.42,0,0,0,1-.31l0,0,.09,0,.1-.06.1-.07.11-.07.1-.08.2-.18a4.78,4.78,0,0,0,.86-1.16c.6-1.08.65-2.63,1.44-2.75h.19c1,.1.74,1.77,1.19,3a3.82,3.82,0,0,0,3.59,2.76l.3,0h.24a3.24,3.24,0,0,0,.55,0l.18,0,.17,0,.11,0a3.17,3.17,0,0,0,.65-.27l.22-.13a2.24,2.24,0,0,0,.38-.31,3.79,3.79,0,0,0,.79-1.08,21.84,21.84,0,0,0,.88-3.11,1.29,1.29,0,0,1,.21-.44,2.16,2.16,0,0,0,.59-1.08,1,1,0,0,0-.54-1l-.54-.12a16.13,16.13,0,0,0-5.44-.35c-1.78.36-2.44.89-3.4.8s-1.41-.74-3-1.42a14,14,0,0,0-5-.66h-.52C373.46,69.5,373.1,69.92,373.06,70.41Zm11.23,2a1.63,1.63,0,0,1,.54-.38l.09-.05.05,0,.26-.1.23-.08a7.88,7.88,0,0,1,.77-.19l.3,0a6.48,6.48,0,0,1,.77-.07h.18a4.23,4.23,0,0,1,3,.86c.36.41.05,2-.19,2.84v.06l0,.06c0,.1-.06.21-.1.33s-.05.14-.07.21h0a3.07,3.07,0,0,1-.14.34h0l-.06.12,0,.07a.2.2,0,0,0,0,.08l-.06.09-.07.11-.07.11-.09.12a2.64,2.64,0,0,1-2.47,1,3.07,3.07,0,0,1-2.4-1.21h0a3.62,3.62,0,0,1-.64-1.76A4,4,0,0,1,384.29,72.42Zm-9.69-1.61a1.78,1.78,0,0,1,.44-.23l0,0,.19-.06.11,0,.1,0,.06,0h.12l.39,0h.43l.27,0h.18c.24,0,.49.08.76.14A4.37,4.37,0,0,1,380.28,72a4.27,4.27,0,0,1-.2,2.51,4.18,4.18,0,0,1-.22.61s0,0,0,0l0,.06,0,0a.43.43,0,0,1,0,.07l-.08.15-.08.13,0,0-.06.09-.06.07h0a2.73,2.73,0,0,1-2.66,1,2.79,2.79,0,0,1-1.23-.42,3.6,3.6,0,0,1-1.27-2.85C374.21,72.78,374.2,71.14,374.6,70.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.12,75.08,382,80.62l-4-1.94.49-.74c.1-.16.2-.32.31-.48l.41-.64c.43-.65.87-1.29,1.29-1.85.13-.19.31-.43.5-.67.37-.47.81-1,1.11-1.31C382.94,73.08,383,74.07,383.12,75.08Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.76,83a1.09,1.09,0,0,0,2.18.1,1.09,1.09,0,0,0-2.18-.1Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.2,90.05c4.11-.59,7.22-1.11,9.3-4.15A25.56,25.56,0,0,0,396.86,81a19.94,19.94,0,0,1-1.62,6.16c-1,1.93-3.4,3.67-9.84,4.38Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.08,74.48a1.18,1.18,0,0,0,1.13,1.23,1.2,1.2,0,0,0,1.19-1.18,1.16,1.16,0,1,0-2.32,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.77,68.74,388.3,70a1.49,1.49,0,0,0-.66-2A1.38,1.38,0,0,0,385.77,68.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.92,69l2.66-1a1.38,1.38,0,0,0-1.81-.84A1.5,1.5,0,0,0,376.92,69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.68,73.73a1.16,1.16,0,1,0,1.08-1.28A1.19,1.19,0,0,0,376.68,73.73Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335,157.32v.54a2.23,2.23,0,0,0,1.1,1.92l38.43,22.45a2.23,2.23,0,0,0,1.09.3,2.3,2.3,0,0,0,1.11-.29l21.08-12a2.19,2.19,0,0,0,1.1-1.9v-.74h0a.27.27,0,0,1-.14.24l-23.14,13.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.64,181.06v1.47a2.23,2.23,0,0,1-1.09-.3l-38.43-22.46a2.18,2.18,0,0,1-1.1-1.91v-.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.74,167.78a.19.19,0,0,0,.1-.17.21.21,0,0,0-.1-.18l-39.53-23.1a1.23,1.23,0,0,0-1.23,0l-22.79,13L375.64,181Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.56,144.25a1.14,1.14,0,0,1,.6.15l39.54,23.1a.12.12,0,0,1,.05.11.1.1,0,0,1-.06.1l-23.05,13.15-40.28-23.54L358,144.4a1,1,0,0,1,.54-.15m0-.17a1.22,1.22,0,0,0-.61.17L335,157.32l40.63,23.74,23.14-13.2a.29.29,0,0,0,0-.51l-39.53-23.1a1.32,1.32,0,0,0-.7-.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.86 179.12 388.23 172.08 352.29 151.08 339.86 158.09 375.86 179.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.86 158.09 340.33 158.36 352.29 151.62 387.75 172.35 388.22 172.08 352.29 151.08 339.86 158.09",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.86 158.09 340.33 158.36 352.29 151.62 387.75 172.35 388.22 172.08 352.29 151.08 339.86 158.09",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.02 159.38 381.8 159.51 375.74 162.96 365.02 156.7 364.8 156.57 371.09 152.99 382.02 159.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.02 159.38 381.8 159.51 375.74 162.96 365.02 156.7 364.8 156.57 371.09 152.99 382.02 159.38",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.8 159.51 375.74 162.96 365.02 156.7 371.09 153.25 381.8 159.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.18,135c-2.43-9.65-4.78-18.9-7.16-26.19-1.31-4-2-9.53-10.56-12.39-5.34,4.12-3.32,15.41-2.44,18.24l5.66,22.15s-1.53,1.88-6.62,6.89c-4.34,4.27-6.44,5.82-11.4,6.6s-5.42.46-8,1.69c-1.36.66-4.47,2.18-5.53,2.76s-2.91,2.61-4.65,4,.5,2.06,1.79,1.63a16.58,16.58,0,0,0,3.85-2.05,21.9,21.9,0,0,1,3.32-1.41,19.6,19.6,0,0,0-.57,3.95c0,.72-.1,1.59.55,2.09a5.47,5.47,0,0,0,1.52.57,1.08,1.08,0,0,0,.33.68,1.86,1.86,0,0,0,1.29.28,5.43,5.43,0,0,0,.72-.14,1.31,1.31,0,0,0,.85,1,5.69,5.69,0,0,0,3.06,0c.15-.06,1.26-.72,1.59-.91s.9-.43,1.1-.75-.5-1.22-1.09-1.29a5.93,5.93,0,0,0-1.94.2,7.29,7.29,0,0,0,.51-1.7c.49-.87,4.36-.15,7.74-.87,2.55-.54,4.37-2.94,5.45-3.62A149.11,149.11,0,0,0,421.74,146C428.27,141,428.49,140.14,427.18,135Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.8,157.12l.66-.25a8.65,8.65,0,0,1,1-2.21C385.72,155,385.16,156.13,384.8,157.12Zm2.7.06a9.39,9.39,0,0,0-.49,2.08,16.39,16.39,0,0,0-.19,2.1,7.94,7.94,0,0,0,.14,2.12,18,18,0,0,1,.17-2.09c.09-.69.17-1.39.28-2.08a13.73,13.73,0,0,1,.39-2,5.56,5.56,0,0,1,.36-1,2.78,2.78,0,0,1,.55-.88A3.9,3.9,0,0,0,387.5,157.18Zm1.95,3a18.2,18.2,0,0,0-.23,2.07,9.66,9.66,0,0,0,.08,2.08c.11-1.38.32-2.73.55-4.08.11-.67.25-1.34.39-2,.08-.33.16-.66.26-1a2.61,2.61,0,0,1,.44-.92,4,4,0,0,0-1,1.82A14.15,14.15,0,0,0,389.45,160.15Zm4.38,2.12a2.4,2.4,0,0,0-.8.2l-.16.07,0,.16a1,1,0,0,1,0,.24.9.9,0,0,1-.07.27,3.64,3.64,0,0,1-.33.55,1.18,1.18,0,0,0,.75-.73,1,1,0,0,0,0-.24,4.78,4.78,0,0,1,.68-.29,3.21,3.21,0,0,1,.85-.16A1.78,1.78,0,0,0,393.83,162.27Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.29,95.71c4.45,1.72,8,3,10.08,9.24,2.48,7.63,5.53,19.28,5.53,19.28s-1.26,3-6.8,4.41-8,0-8,0-2.79-9.68-3.87-13.71S403.28,99.2,409.29,95.71Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M375,181.38a2.62,2.62,0,0,1-2.25-.18l-38.26-22.36a2.62,2.62,0,0,1-1.26-1.83l-4.07-25.08a2,2,0,0,1,0-.42,2.65,2.65,0,0,1,.79-1.86l39.76,23.24a2,2,0,0,1,.93,1.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.64,181.06l-.26.15a2.92,2.92,0,0,1-.36.17l-4.4-27.14a2,2,0,0,0-.93-1.35l-39.76-23.24a2.73,2.73,0,0,1,.53-.4l39.84,23.28a1.92,1.92,0,0,1,.93,1.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.25,153.4l.62-.35a1.92,1.92,0,0,1,.36.84l4.41,27.17-.26.15a2.92,2.92,0,0,1-.36.17l-4.4-27.14A1.87,1.87,0,0,0,370.25,153.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.52,158.14a8.45,8.45,0,0,0-3.84-5c-1.85-1.08-3.13-.6-2.85,1.08a8.46,8.46,0,0,0,3.84,5C352.52,160.31,353.8,159.82,353.52,158.14Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.74,131.08c-1.09-1.43-2.57-4.54-1.54-9.8.68-3.45,3.79-6.32,7.17-10.14,4.29-4.85,7-6.86,6.87-11.56-.08-3.69-.36-4.09.68-6.53.56-1.3,1.85-4.27,2.36-5.28s2.32-2.83,3.54-4.51,1.95.38,1.6,1.61a16,16,0,0,1-1.76,3.68,20.35,20.35,0,0,0-1.19,3.15,19.3,19.3,0,0,1,3.67-.69c.67,0,1.49-.15,2,.43a5.08,5.08,0,0,1,.59,1.4,1,1,0,0,1,.65.27,1.75,1.75,0,0,1,.32,1.2,6.33,6.33,0,0,1-.1.68,1.25,1.25,0,0,1,1,.75,5.32,5.32,0,0,1,.11,2.86c-.05.14-.62,1.21-.78,1.53a2.92,2.92,0,0,1-.66,1.05c-.35.24-1.16-.41-1.25-1a5.74,5.74,0,0,1,.11-1.82,6.61,6.61,0,0,1-1.57.54c-.79.5.35,1.68-.19,4.87-.4,2.4-2.47,3.94-3.06,5-3.6,6.3-4.44,12.75-8.65,17.88C361.93,128.72,355.66,133.57,353.74,131.08Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.45,92.72a8.5,8.5,0,0,1,2-1c.08-.21.15-.41.21-.62C370.78,91.46,369.7,92,369.45,92.72Zm.82,2.08a2.93,2.93,0,0,1,.8-.55,7,7,0,0,1,.89-.38,14.3,14.3,0,0,1,1.88-.44c.64-.13,1.28-.24,1.93-.35a17.72,17.72,0,0,1,1.94-.24,7.71,7.71,0,0,0-2,0,18.47,18.47,0,0,0-2,.27,8.72,8.72,0,0,0-1.92.54A3.63,3.63,0,0,0,370.27,94.8Zm2.57,1a3.64,3.64,0,0,0-1.66,1,2.19,2.19,0,0,1,.84-.44,8.78,8.78,0,0,1,.91-.29c.61-.16,1.23-.32,1.86-.45,1.25-.27,2.5-.52,3.79-.68a9.08,9.08,0,0,0-1.95,0,17.44,17.44,0,0,0-1.92.3A13.74,13.74,0,0,0,372.84,95.84Zm4.13,4.38a3.44,3.44,0,0,1,.11-.81,4.41,4.41,0,0,1,.25-.64.59.59,0,0,0,.22,0,1.14,1.14,0,0,0,.3-.18,1.16,1.16,0,0,0,.35-.55,2.87,2.87,0,0,1-.5.33,1.21,1.21,0,0,1-.25.08.57.57,0,0,1-.22,0h-.15l-.06.15a2.53,2.53,0,0,0-.16.76A1.72,1.72,0,0,0,377,100.22Z",
    style: {
      fill: "#af6152"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Legs--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.77,348.71c-.84,2.27-4.8,1.86-9.06,2-3.43.11-7.41-.52-9.59.61s-2.62,3.8,1,6.81c4.51,3.77,10.48,3.35,13.82,3.67s5.32,1.5,8.36,1.41c3.93-.11,6.23-1.46,6.75-2.59s-.08-9.55-1.71-9.13c0,0,.16-.27-5.61-.46C394.7,350.88,394.77,348.71,394.77,348.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.31,352c0-.13,1-7.91,1-7.91s-.15-.68-4.83-.84c-2.3-.08-5-2-5.23-.17s-.44,5.65-.44,5.65c-.84,2.27-4.8,1.86-9.06,2-.71,0-1.45,0-2.2,0h0c-2.28.2-4.35,1.89-1.72,3.47s6.61,1.75,10.28,1.88C396.44,356.2,404.16,356.36,404.31,352Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.63,298.91c-.36,8.49.8,48.55.8,48.55s4.05,2,10.62-.32l4.38-43.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.44,358.67c-.77,2.3-6.9,3.3-11.15,3.58-3.43.22-7.42-.28-9.56.93s-2.49,3.88,1.22,6.77c4.63,3.61,12.74,1.72,16.09,1.93s5.27.91,8,.89c3.93,0,5.29-1.47,5.76-2.61s.93-9.51-.69-9c0,0,.16-.27-5.62-.27C374.43,360.85,374.44,358.67,374.44,358.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.08,361.62c0-.13,3.11-12.43,3.11-12.43a9.42,9.42,0,0,1-7.28,3.82c-2.3,0-5-1.83-5.23,0s-.16,3.5-.42,5.18-5.3,3.3-9.94,3.82c-.71.08-2.48.3-3.22.3h-.05c-2.57.23-5.15,2.27-2.47,3.76s9.7,0,13.37,0C376.36,366.1,384.08,366,384.08,361.62Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.61,314.3c-1,8.79-1.95,33.74-2.17,40.71,0,0,5.83,2.38,11.33.7,0,0,7.7-25,7.13-34.43C392.62,316.81,376.61,314.3,376.61,314.3Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M468.23,385.42l-6.33-52.85-5.18-.26,8.9,53.1h0a.66.66,0,0,0,.34.46,2.08,2.08,0,0,0,1.85.1.62.62,0,0,0,.4-.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.31,327.78h-5.18l-7.54,49.9h0a.61.61,0,0,0,.38.57,2,2,0,0,0,1.84,0,.67.67,0,0,0,.37-.44h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.13,327.78,390,341.71a20.68,20.68,0,0,0,4,2.43l3.31-16.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.61,403.13l-4.87-53.73-5.18-.26,7.44,54h0a.68.68,0,0,0,.34.47,2,2,0,0,0,1.85.09.63.63,0,0,0,.41-.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.45,357.25l-.71-7.85-5.18-.26,1.17,8.49A9.35,9.35,0,0,0,429.45,357.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.59,311.34h-5.18l-7.54,49.9h0a.62.62,0,0,0,.37.57,2.08,2.08,0,0,0,1.85,0,.68.68,0,0,0,.37-.45h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.94,326.75c-.73-4.08,2.6-7.27,8.87-11.5A147.1,147.1,0,0,1,416,305.05c5.24-2.4,10.6-2.18,17.31,1.27,9.32,4.79,37.36,21.79,37.36,21.79s-41.93,23.68-50,22.62-28.23-14.18-29.83-18.79S388.94,326.75,388.94,326.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.94,326.75c-.73-4.08,2.6-7.27,8.87-11.5A147.1,147.1,0,0,1,416,305.05c5.24-2.4,10.6-2.18,17.31,1.27,9.32,4.79,37.36,21.79,37.36,21.79s-41.93,23.68-50,22.62-28.23-14.18-29.83-18.79S388.94,326.75,388.94,326.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M424.68,345.75c-6,5.45-12.31.76-22.26-5.7-11.27-7.31-13.48-13.3-13.48-13.3s0,4.49.84,6.59,2.66,4.48,10.79,10.08,14,8.41,19.47,9.45l4.31-.6",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.42,340.05c-11.27-7.31-13.48-13.3-13.48-13.3s0,4.49.84,6.59,2.66,4.48,10.79,10.08,14,8.41,19.47,9.45l4.31-.6.33-6.52C418.66,351.2,412.37,346.51,402.42,340.05Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.82,309.59s-35.21-10.62-41.33-12.3-17.86-4.5-21.29-3-5.18,3.32-5.49,8.27c-.06.93,0,5.46,0,5.46s17,5.26,31,5.26S457.82,309.59,457.82,309.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.32,306.09c2.21,7.53,3.38,16.72-1.9,22.16-3.84,3.95-13.63,13.08-34.67,12.19-9.52-.4-36.2-19-36.2-19s-10.07-1.6-10.13-5.13c0-.87-1-1.08-.81-2,1.45-7.73,6.3-11.5,13.07-10.95,11.26.91,36.45,8,36.45,8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.56 245.54 423.07 260.81 436.01 258.12 431.54 241.23 419.56 245.54",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.23,248.84c2-.63,6.65-.94,9.16.61s5,4.42,7.19,12c1.73,5.86,5.66,21.62,5,26.69s-18.88,8.34-18.88,8.34Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.22,295.32a52.38,52.38,0,0,1-5.5-12.91c-1.68-10.86,2.12-15.75-2-26.25-1.88-4.79-7.85-8.33-12.87-7.1-1.3.31-1.83.33-3.06.65.88,2.54-8.35,5.23-12.59,2.88-1.8.56-10.44,4.4-10.44,4.4-1.82,3.64-2.88,7.8-3.76,15.65-.36,3.18,1,6.67,2.7,9.73A42.4,42.4,0,0,1,415,309c0,.26-.07.53-.11.81,0,0,7.83,8.74,27,5.25,17.08-3.11,17.6-14.55,17.6-14.55A51.77,51.77,0,0,0,457.22,295.32Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,295.45c.64-6.42,2-14.75,3.26-24.25,1.23-9.24,3.48-11.67,9.46-14.21,8.69,5.35,5.73,22.57,5.73,22.57s-2.13,11.37-4.46,20.19c-1,3.9-3.17,10.39-9.24,9.74C398.12,309,397.31,302.61,398,295.45Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.51,230.62s-3.09,4.86-2.69,5.29,2.69.79,2.69.79Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.47,216.51c-2.69,1.58-7.33,4.48-8,14.74-.7,10.53.86,14.11,2.36,15.41,1,.87,7.92,1.07,9.83.44,3.24-1,9.71-5.56,12.71-11.14,3.53-6.56,3.87-15.07-.78-18.15C427,213.48,419.75,215.18,417.47,216.51Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.54,247.23a9.56,9.56,0,0,1-4-2.08c-1.33-1.07-3.33-5.7-3.19-7,.05,0,1.85,1.32,4.24-1s2.48-6.65-.8-7.55c-2.34-.66-4,1.16-4.87,3-.15.3-.34.63-.66.7-.5.12-.88-.44-1.07-.92a4.54,4.54,0,0,0-.8-1.6,4.32,4.32,0,0,1-1.34-2.7,10,10,0,0,1,.22-2.62,8.8,8.8,0,0,0-2.39,3.41,5.51,5.51,0,0,1,.07-4.94,9.62,9.62,0,0,0-2.27,4.44,5.06,5.06,0,0,1-1.58-3.14,10.77,10.77,0,0,1,3-8.74,18.66,18.66,0,0,1,8.13-4.82,24.94,24.94,0,0,1,9.13-1.05c6.54.39,10.09,3.58,11.1,4.77a9.56,9.56,0,0,1,1.64,4.45c3.93,2,4,6.91,3.14,10.67-.77,3.29-3,6.26-5.11,8.81-1.11,1.34-2.27,2.64-3.33,4a16.34,16.34,0,0,0-1.46,2.06c-.63,1.14-1.08,2.1-1.08,2.1A20.24,20.24,0,0,1,426.54,247.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,247.47l-.38-1.58a13.51,13.51,0,0,1-4.18.68c-3,.16-4-.35-4.05-.37a3.24,3.24,0,0,0,.44.46C412.68,247.39,417.29,247.78,420,247.47Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.35,352.27c3.43-.17,6.11-2.69,14.26-6.08C453.66,339.92,465,334.9,469.25,327s7.34-43.24,6.27-53.09a13,13,0,0,0-.74-3.27l1.06-.15-2.74-2.33h0c-2.82-2.29-7.39-.25-10.84,1.63-9.85,5.36-17.56,10.57-23.65,29.38-4.58,14.15-7.6,39.66-13.93,46.56",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.78,270.66l1.06-.15-2.74-2.33h0c-2.82-2.29-7.39-.25-10.84,1.63-9.85,5.36-17.56,10.57-23.65,29.38-4.58,14.15-7.6,39.66-13.93,46.56l-.33,6.52c3.43-.17,6.11-2.69,14.26-6.08C453.66,339.92,465,334.9,469.25,327s7.34-43.24,6.27-53.09A13,13,0,0,0,474.78,270.66Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.87,271.08c-9.85,5.36-19.11,11.22-24.33,30.5-5.17,19.09-8.5,48.06-20.5,51.29,0,0,5.43,2.15,22.06-4.88,5.29-2.24,11.71-6.32,15.93-8.69,8.27-4.64,13.28-8.44,14.07-9.86,4.37-7.85,7.35-43.23,6.27-53.09S469.8,268.39,464.87,271.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.87,271.08c-9.85,5.36-19.11,11.22-24.33,30.5-5.17,19.09-8.5,48.06-20.5,51.29,0,0,5.43,2.15,22.06-4.88,5.29-2.24,11.71-6.32,15.93-8.69,8.27-4.64,13.28-8.44,14.07-9.86,4.37-7.85,7.35-43.23,6.27-53.09S469.8,268.39,464.87,271.08Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--legs--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.52,395.81c0-.12,1.89-7,1.89-7s-.61.63-4.57-.41a22.52,22.52,0,0,1-4.3-1.8l-1.12,5c-1.06,1.93-4.55,1-8.37.61-.64-.08-1.31-.18-2-.3h0c-2.06-.12-4.13,1.12-2,2.89s5.69,2.42,8.95,3C308.93,398.55,315.82,399.7,316.52,395.81Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.07,395.2a4.11,4.11,0,0,0-.29,2.1c.08.77,2,3.35,5.29,4.93s7.44,1.69,9.37,2.24,3.69,1.66,6,2.22,4.51.84,6.79-.66a5.07,5.07,0,0,0,.75-2.28C316.58,403.36,289.07,395.2,289.07,395.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.82,392.3c-1.47,1-4.5.31-7.77-.06-3.09-.35-6.56-1.44-8.66-.71s-3.85,3.2-1,6.36a12.33,12.33,0,0,0,3.94,3c3.53,1.26,6.69,1.36,9,1.92,3,.73,4.56,2,7.29,2.35,3.53.41,5.77-.5,6.38-1.44s1.17-8.55-.34-8.39c0,0-.64,2.46-6.4.07C307.68,394.39,307.72,392.85,307.82,392.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,396.38s.33-3.21,2.7-4.06a1.25,1.25,0,0,1,1.31.17s-2.21.32-2.93,4.09c0,0-.11.25-.59.16C298.36,396.71,298,396.65,298,396.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.06,392.74s0-.1-.56-.21a1,1,0,0,0-.65.07s-1.77.77-2.1,4.12a.61.61,0,0,0,.55.52.49.49,0,0,0,.63-.33S302.29,393.38,304.06,392.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,392.81s-.1-.2-.52-.2-.64.21-.64.21a6.08,6.08,0,0,0-1.28,4.09s0,.48.61.53.57-.49.57-.49S304.93,393.37,306,392.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.42,350.71c-2.2,9.31-9,37.21-9,37.21s5,4.49,10.4,2.44c5.76-15.22,16.1-25.63,16-36.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.42,350.71c-2.2,9.31-9,37.21-9,37.21s5,4.49,10.4,2.44c5.76-15.22,16.1-25.63,16-36.78Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.68,405.47c.59-.88,2.8-7,2.8-7s-2.31,1.32-6.29.37a9.26,9.26,0,0,1-3.91-2.68l-1.7,5.85c-1,1.95-4.25,1.31-8.09,1-.64-.06-1.3-.15-2-.25h0c-2.06-.07-4.11,1.22-1.92,2.93s5.75,2.29,9,2.8C288.53,409.11,294.47,408.75,296.68,405.47Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.94,405.28a4.36,4.36,0,0,0-.25,2.27c.1.81,2.19,3.54,5.8,5.15s8,1.61,10.12,2.16,4,1.68,6.46,2.22,4.87.78,7.27-.88a5.64,5.64,0,0,0,.75-2.48C296.69,413.31,266.94,405.28,266.94,405.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,401.62a6.67,6.67,0,0,1-.72.45,2.43,2.43,0,0,1-.81.16,11.29,11.29,0,0,1-1.93,0c-1.62-.08-3.23-.33-4.84-.47-3.32-.3-7.08-1.37-9.32-.53s-4.27,3.52-1.14,6.85a15.22,15.22,0,0,0,4.19,3.17c3.71,1.56,7.56,1.27,10,1.81,3.18.7,4.95,2.06,7.89,2.33,3.8.35,6.17-.69,6.81-1.72.35-.57,0-3.55.43-5.87.41-2,.31-3.35-.41-3.26a3.43,3.43,0,0,1-.56.71,2.73,2.73,0,0,1-.84.67,7.75,7.75,0,0,1-1.43.48,8.46,8.46,0,0,1-2.64.36,1.26,1.26,0,0,1-.72-.23,1.46,1.46,0,0,1-.42-.9c-.06-.29-.13-.58-.19-.88a1.26,1.26,0,0,0-.16-.46,1.33,1.33,0,0,0-.45-.36,3.78,3.78,0,0,1-1.45-1.1,3.38,3.38,0,0,1-.42-1.36c0-.09,0-.18-.1-.23s-.27,0-.38.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.59,406.31s.27-3.46,2.79-4.43a1.34,1.34,0,0,1,1.41.15s-2.35.4-3,4.46c0,0-.11.27-.63.19C277,406.65,276.57,406.6,276.59,406.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,402.24s0-.11-.6-.21a1,1,0,0,0-.7.1s-1.88.87-2.15,4.48a.65.65,0,0,0,.6.54.52.52,0,0,0,.67-.37S281.09,403,283,402.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,402.27s-.11-.22-.56-.2-.69.24-.69.24a6.58,6.58,0,0,0-1.26,4.43s0,.51.67.54.6-.54.6-.54S283.92,402.9,285,402.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.62,359.58c-2.27,7-8.09,26.93-10.74,37.18,0,0,4.77,4.29,10.91,3.91,3.25-7.65,18.08-28.87,16.28-37.95-1.14-5.73-7.38-4.06-7.38-4.06Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.62,359.58c-2.27,7-8.09,26.93-10.74,37.18,0,0,4.77,4.29,10.91,3.91,3.25-7.65,18.08-28.87,16.28-37.95-1.14-5.73-7.38-4.06-7.38-4.06Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.84,371.11c-2.12-1.5-6.91-4.48-7.46-6,0,0,.74,4.8,6.68,8.12Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391.6,430.12l-6.33-52.84L380.1,377l8.9,53.1h0a.74.74,0,0,0,.35.46,2,2,0,0,0,1.84.09.63.63,0,0,0,.41-.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.69,372.49h-5.18L308,422.39h0a.65.65,0,0,0,.38.57,2.08,2.08,0,0,0,1.85,0,.77.77,0,0,0,.37-.45h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.51,372.49l-2.11,13.92a20.31,20.31,0,0,0,4,2.44l3.31-16.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,447.84l-4.87-53.74-5.17-.26,7.44,54h0a.66.66,0,0,0,.35.46,2,2,0,0,0,1.84.1.63.63,0,0,0,.41-.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.83,402l-.72-7.86-5.17-.26,1.17,8.5A9.47,9.47,0,0,0,352.83,402Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,356.05h-5.18L336.25,406h0a.65.65,0,0,0,.38.57,2.08,2.08,0,0,0,1.85,0,.77.77,0,0,0,.37-.45h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.32,371.46c-.73-4.09,2.6-7.28,8.86-11.5a148.57,148.57,0,0,1,18.15-10.2c5.24-2.41,10.6-2.18,17.31,1.26,9.32,4.79,37.37,21.8,37.37,21.8s-41.93,23.68-50,22.61-28.24-14.17-29.83-18.79S312.32,371.46,312.32,371.46Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.32,371.46c-.73-4.09,2.6-7.28,8.86-11.5a148.57,148.57,0,0,1,18.15-10.2c5.24-2.41,10.6-2.18,17.31,1.26,9.32,4.79,37.37,21.8,37.37,21.8s-41.93,23.68-50,22.61-28.24-14.17-29.83-18.79S312.32,371.46,312.32,371.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.06,390.45c-6,5.45-12.31.76-22.27-5.7-11.26-7.31-13.47-13.29-13.47-13.29s0,4.48.84,6.58,2.66,4.49,10.78,10.09,14,8.4,19.48,9.44l4.31-.59",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.79,384.75c-11.26-7.31-13.47-13.29-13.47-13.29s0,4.48.84,6.58,2.66,4.49,10.78,10.09,14,8.4,19.48,9.44l4.31-.59.33-6.53C342,395.9,335.75,391.21,325.79,384.75Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.27,349.86c-7.79-.78-30-6.36-35.42-7.28-10.36-1.78-15.64-2-18.62-1.1s-5.54,4.27-6.46,7.84c-1.08,4.22-1.64,6.36-1.64,6.36s22.78,8,34.29,9.36S378.27,349.86,378.27,349.86Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.27,349.86c-7.79-.78-30-6.36-35.42-7.28-10.36-1.78-15.64-2-18.62-1.1s-5.54,4.27-6.46,7.84c-1.08,4.22-1.64,6.36-1.64,6.36s22.78,8,34.29,9.36S378.27,349.86,378.27,349.86Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.27,349.86c.43,11,.06,21.25-5.22,26.79-3.56,3.73-21.42,13.41-32.94,9.59-11.35-3.75-34.85-21.2-37.21-23s-4.5-2.95-4.28-3.7c3.17-10.52,7.8-11.35,16.39-9.46,10.51,2.31,33.57,11.73,33.57,11.73Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.27,349.86c.43,11,.06,21.25-5.22,26.79-3.56,3.73-21.42,13.41-32.94,9.59-11.35-3.75-34.85-21.2-37.21-23s-4.5-2.95-4.28-3.7c3.17-10.52,7.8-11.35,16.39-9.46,10.51,2.31,33.57,11.73,33.57,11.73Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.31,299.75c6.09-.9,11.71.76,13.3,7.3,1.17,4.81-5.7,19.57-9.26,28.34,0,0-13.78-.56-15-10.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.8,277.64s-4.62,5.57-4.29,6.07a13.53,13.53,0,0,0,2.9,1.69Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.75,267.68c-2.45.83-3.29,2.89-3.74,6.91-.19,1.68.55,4.27,0,6-1.6,4.9-.57,13.22.75,14.78.89,1.06,6.6,2.78,9.42,2.33,3.53-.57,11.35-3.09,15.49-8.05,4.88-5.83,6.81-14.18,2.54-18.1C371.19,266.06,355.36,266.78,352.75,267.68Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.63,297.86l-.26-4.51-14,2.46.31,3.14c.17,1.76.31,3.57-.85,4.25-2.09,1.22-5.53,3.11-7.85,4.52,0,0,10.12,1.23,17.75,0s6.53-7.84,6.53-7.84C373.89,299.87,372.73,300,372.63,297.86Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,295.63a16.6,16.6,0,0,0,8.59,2.23l-.2-2.05a20.58,20.58,0,0,1-4.94.45A10.69,10.69,0,0,1,350,295.63Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.09,268.58a3.54,3.54,0,0,0-.69,1.81,3.07,3.07,0,0,0,1.41,2.85,2.66,2.66,0,0,0,3.11-.27,3.42,3.42,0,0,0,.81,3.16,2.43,2.43,0,0,0,3.1.29c-.28.59-.51,1.39,0,1.79a1.11,1.11,0,0,0,.43.19,2.32,2.32,0,0,0,1.38-.09,2.19,2.19,0,0,0-.58,1.93c.06.23,1.17,1.63,1.24,1.46,0,0,1.42-3.92,4.77-3.09s3.4,5.24,1,7.68-4.28,1.24-4.31,1.23c0,.7-.08,4.5,3,6.69,1.92,1.35,7,1.64,9.62,0,1-1.75,2.62-4,3.89-5.95,4.25-6.59,5.65-10.64,4.91-14.35-.51-2.53-1.64-4-3.55-4.45a7.71,7.71,0,0,0-3-6.47c-4.05-3.49-8.74-3.79-12.37-3.62a21.4,21.4,0,0,1-3.75.1c-1.07-.15-2.08-.6-3.15-.79a3.34,3.34,0,0,0-3,.73,3.46,3.46,0,0,0-.49,3.24,5.28,5.28,0,0,0-2.5.71,3,3,0,0,0-1.43,2.1,2.08,2.08,0,0,0,1.19,2.14A3.93,3.93,0,0,0,348.09,268.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.66,343.94c-.53,2.73-1.1,5.45-1.54,8.19-.59,3.61-1.32,7-2.1,10.61a2,2,0,0,1-.28.78,2,2,0,0,1-.74.52,68.1,68.1,0,0,1-10.91,4.38,48.26,48.26,0,0,1-12.8,1.23c-7.9-.67-13.05-3.43-18.74-8.95,1.39-3.15,2.23-4.35,3.16-7.67,1-3.71,1.37-5.73,2.07-12.47,2-19.07,4.41-30.38,9.28-34.07,4.73-2.1,5.37-2.45,7.78-3.29,1.09.52,3.9,1.39,8.46,1,5.65-.49,8-3.6,8-4.35l1-.11a17.51,17.51,0,0,1,4.14,1.71c1.38.74,4.74,2.1,6.05,8.47C388.33,323.72,384.25,335.85,382.66,343.94Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.29,300.13a18,18,0,0,1,4,1.66l.3.16c1.53.79,4.37,2.27,5.56,8.06,2.31,11.27-.07,21.62-1.81,29.19-.39,1.66-.75,3.23-1,4.67l-.33,1.65c-.42,2.14-.86,4.36-1.22,6.55-.57,3.53-1.28,6.85-2,10.37l-.05.22a1.68,1.68,0,0,1-.22.63,1.5,1.5,0,0,1-.6.41A67.34,67.34,0,0,1,367,368.06a49,49,0,0,1-11,1.27c-.66,0-1.23,0-1.7-.06-7.32-.62-12.47-3-18.31-8.66.35-.79.68-1.48,1-2.08a31,31,0,0,0,2.1-5.4c1-3.68,1.36-5.67,2.08-12.53,1.83-17.49,4.08-29.93,9.1-33.78l2.55-1.14c2.46-1.1,3.25-1.45,5-2.07a15.74,15.74,0,0,0,6.28,1.07c.72,0,1.47,0,2.23-.1,5.26-.45,7.81-3.14,8.25-4.38l.71-.07m0-.38-1,.11c.05.75-2.32,3.86-8,4.35-.79.06-1.52.09-2.2.09a15.14,15.14,0,0,1-6.26-1.1c-2.41.84-3,1.19-7.78,3.29-4.87,3.69-7.28,15-9.28,34.07-.7,6.74-1,8.76-2.07,12.47-.93,3.32-1.77,4.52-3.16,7.67,5.69,5.52,10.84,8.28,18.74,8.95.49,0,1.08.06,1.73.06a49.28,49.28,0,0,0,11.07-1.29A68.1,68.1,0,0,0,378,364a2,2,0,0,0,.74-.52,2.16,2.16,0,0,0,.29-.78c.77-3.6,1.5-7,2.09-10.61.44-2.74,1-5.46,1.54-8.19,1.59-8.09,5.67-20.22,2.84-34-1.31-6.37-4.67-7.73-6.05-8.47a17.51,17.51,0,0,0-4.14-1.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.22,356.31c-5.71-1.86-8.27-8.14-10.21-14.92-.6-2.09-1.22-4.22-2-6.25s-1.86-4.28-2.64-6.47a29.72,29.72,0,0,1-1-3.57c-.66-2.84-.31-6-.12-8.87a15.66,15.66,0,0,1,.24-2.17,8.91,8.91,0,0,1,.83-2.3c.3-.56.83-1.16,1.44-1a1.28,1.28,0,0,1,.8.9,6.86,6.86,0,0,0,.41,1.18c1.18,1.94,3.15-.47,4.08-1.26.49-.41,1.57-1.43,2.31-1.08,1.74.82,5.12,7.07,5,10.28s-2.25,8.29-1.43,11.27,6.55,12.5,6.55,12.5Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.55,325.71l-7.34-25.9a1.38,1.38,0,0,0-1.12-1,2.13,2.13,0,0,0-1.6.08l-12.44,7.19a1.28,1.28,0,0,0-.63,1.38l7.34,25.9a1.5,1.5,0,0,0,1.06.88,2.26,2.26,0,0,0,1.66,0l12.44-7.19A1.13,1.13,0,0,0,329.55,325.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.72,326l-12.8,7.39-7.37-26-2.05-.66a1.1,1.1,0,0,0-.08.77l7.34,25.9a1.5,1.5,0,0,0,1.06.88,2.26,2.26,0,0,0,1.66,0l12.44-7.19a1.3,1.3,0,0,0,.66-.79l-.06,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.11,299.66l-12.48,7.2a.92.92,0,0,0-.44,1l7.28,25.69a.78.78,0,0,0,1.22.4l12.15-7a1,1,0,0,0,.5-1.1L322,300A.58.58,0,0,0,321.11,299.66Z",
    style: {
      fill: "#455a64"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M321.67,301.23l6.81,24a1,1,0,0,1-.48,1l-11.25,6.5a.55.55,0,0,1-.86-.27L309,308.32a1,1,0,0,1,.29-.9l.06-.06.13-.09,3.17-1.83.2-.11a.17.17,0,0,1,.27.08c0,.11.15.15.28.08l3.68-2.13a.31.31,0,0,0,.17-.33.3.3,0,0,1,.12-.31l0,0,3.1-1.78.07,0A.69.69,0,0,1,321.67,301.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.71,325.72a1,1,0,0,0,.48-1L320.46,301l-3,1.75,0,0a.3.3,0,0,0-.12.31.31.31,0,0,1-.17.33l-3.68,2.13c-.13.07-.25,0-.28-.08a.17.17,0,0,0-.27-.08l-.2.11-3.17,1.83-.13.09-.06.06a1,1,0,0,0-.29.9L315.76,332Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.79,304.48l1.69-1c.1-.06.21,0,.23.06a.26.26,0,0,1-.13.28l-1.69,1c-.1.05-.21,0-.23-.07A.25.25,0,0,1,313.79,304.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.33,302.93a.16.16,0,0,1,.26.09.29.29,0,0,1-.14.32c-.12.06-.24,0-.27-.09A.32.32,0,0,1,316.33,302.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.61,310.51a.84.84,0,0,0-.51-.48.38.38,0,0,0-.26,0l-.24.14q-.11.06-.06.21l.6,2.11a.84.84,0,0,0,.51.48.35.35,0,0,0,.25,0l.25-.14q.11-.06.06-.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.37,310.65l.6,2.11c0,.19-.09.28-.32.21a.84.84,0,0,1-.51-.48l-.6-2.11c-.06-.19.09-.28.32-.21A.84.84,0,0,1,308.37,310.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.66,314.2a.84.84,0,0,0-.51-.48.32.32,0,0,0-.26,0l-.25.14a.17.17,0,0,0-.06.2l.6,2.11a.86.86,0,0,0,.52.48.31.31,0,0,0,.25,0l.25-.15a.17.17,0,0,0,.06-.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.42,314.34l.6,2.11c.05.19-.09.29-.32.21a.86.86,0,0,1-.52-.48l-.6-2.11c-.05-.19.09-.28.32-.21A.89.89,0,0,1,309.42,314.34Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M310.28,323.17c.26-.43.53-.86.8-1.27a59.8,59.8,0,0,1,3.71-5c1.37-1.71,2.1,0,2.21,1.47.22,3.12-2.17,5.35-2.63,8.33-.12.77-.13,1.56-.21,2.34a27.05,27.05,0,0,1-1.44,4.85c-.15.51-.38,1.05-1,1s-.77-.76-1-1.24a14.78,14.78,0,0,1-1.1-3,12.45,12.45,0,0,1-.57-3.92A7.9,7.9,0,0,1,310.28,323.17Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.38,339.41c2.9-5.29,8.09-13.42,13.19-21.91,5-8.25,7.51-8.74,13.58-11.14C359,317,347,336,347,336s-9.85,12.19-14.14,17c-2.8,3.1-8,5.84-11.19,2.16S320.48,344.7,323.38,339.41Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M347.73,397c3.42-.17,6.11-2.69,14.26-6.09,15.05-6.27,26.33-11.28,30.63-19.17s7.35-43.23,6.27-53.08a13,13,0,0,0-.73-3.27l1.06-.15-2.75-2.34h0c-2.81-2.3-7.39-.25-10.83,1.63-9.86,5.36-17.56,10.57-23.65,29.38-4.58,14.15-7.61,39.65-13.93,46.55",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.16,315.37l1.06-.15-2.75-2.34h0c-2.81-2.3-7.39-.25-10.83,1.63-9.86,5.36-17.56,10.57-23.65,29.38-4.58,14.15-7.61,39.65-13.93,46.55l-.33,6.53c3.42-.17,6.11-2.69,14.26-6.09,15.05-6.27,26.33-11.28,30.63-19.17s7.35-43.23,6.27-53.08A13,13,0,0,0,398.16,315.37Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.25,315.78c-9.86,5.37-19.11,11.23-24.33,30.51-5.17,19.09-8.5,48.06-20.5,51.28,0,0,5.42,2.16,22.06-4.87,5.29-2.24,11.71-6.32,15.93-8.69,8.27-4.64,13.28-8.44,14.07-9.86,4.37-7.85,7.34-43.24,6.27-53.09S393.18,313.1,388.25,315.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.25,315.78c-9.86,5.37-19.11,11.23-24.33,30.51-5.17,19.09-8.5,48.06-20.5,51.28,0,0,5.42,2.16,22.06-4.87,5.29-2.24,11.71-6.32,15.93-8.69,8.27-4.64,13.28-8.44,14.07-9.86,4.37-7.85,7.34-43.24,6.27-53.09S393.18,313.1,388.25,315.78Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.13,280l-21.3,12.29-2.33,1.35L74.5,311c.87-10.91,3-36.62,5-58.66l48.12-.29C127.89,260.53,128.05,270.31,128.13,280Z",
    style: {
      fill: "#263238"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.28,270.69c-.16.44-2.89,7.43-10.29,9.13l-2.16,12.46-2.33,1.35,2-15.56A24.2,24.2,0,0,0,119.28,270.69Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.61,192.14c5.1.65,6.26,1,16.3,7,8.18,4.91,14.19,8.37,14.19,8.37s6.84,6.83,7.45,8.53.19,6.41-2.85,9.27c-2.51,2.35-4,1.59-6.16.85-2.66-.9-20.68-8.82-20.68-8.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.44,183.2c-1.17-.81-1.47.31-1.9.43,0,0,1.36-1.36-.66-2.77-1.24-.87-2,.91-2,.66s1.84-3.7,3.35-6.76c1.43-2.9.44-3.83,0-4.1s-1-.11-2.26,2-5.07,8.37-5.92,9.67-1.43,1.9-1.79.1a10,10,0,0,0-1.5-4.35c-1.48-1.8-2.78-1.15-2.62.16.22,1.84,0,4,.08,7,0,1.56-.05,3,0,4.09.28,3.77-2,5.33-4.81,8.07-2.28,2.24-6.28,5.31-11.22,10.05-3.15,3-4.17,13-.22,16.56s6.46.71,12.06-6.49c3.6-4.65,8.62-13.32,10-15.3s1.88-3.23,3.62-4.13a12.12,12.12,0,0,0,4.88-4.72c.68-1,2-2.85,2.81-4.36s1-2.61.17-3.34c-1.15-1-1.6.32-1.71.17S180.1,184.36,178.44,183.2Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.17,190.91c-.37-.63.12-1.69.12-1.69a2.1,2.1,0,0,1-1.06.77,1.5,1.5,0,0,1-1.66-.9,2.21,2.21,0,0,1,.35-1.41,2.51,2.51,0,0,1-1.1.5c-.68.13-1.25-.34-1.44-1.17s.91-2.77,2-4.54a9.3,9.3,0,0,0-1.64,1.94,5,5,0,0,0-1.05,2.45,5.11,5.11,0,0,0-1.82-1.76c1.57,1.79,2.44,6.37,1.49,9.29a6.6,6.6,0,0,0,1.08-5.84,1.33,1.33,0,0,0,1.57,0,1.58,1.58,0,0,0,.79,1.73,1.55,1.55,0,0,0,1.72.16s-.26.65.59,1.18,1.58.08,2.14-.74A1.38,1.38,0,0,1,176.17,190.91Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.28,196.44a26.06,26.06,0,0,0-4.48,17.94c1,9.41,1.84,15.48,2,19.13.18,5.6-1.18,28.11-1.18,28.11,6.91,8.4,41.66,9.12,49.37-6.32,0,0-.37-12.22-.39-24.74,0-9.16.12-17.57-1-23-1.54-7.23-5.39-13.64-8.9-15.46l-8.64-.49-10.89-.53Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95,186.58c-.72-3.59-4.41-7.25-6.11-10.35s-2.63-5.31-2.53-8.16a6.17,6.17,0,0,1,1.92-4.63c-.32-6.16,5.91-9.7,10.07-10.88a28.52,28.52,0,0,1,13.16-.49c2.34.42,4.44,1.29,6.31-.77a3.78,3.78,0,0,1-.71,4.6,5.25,5.25,0,0,1,2.53.92,2.52,2.52,0,0,1,1.25,2.28,3.35,3.35,0,0,1-1,1.62,2.33,2.33,0,0,1,1.27,2.77,3.32,3.32,0,0,1-1.09,1.66c-.27.23-.64.36-.9.59s-.27.41-.46.61-.12.65-.15.85a4.1,4.1,0,0,1-.58,1.62,5.8,5.8,0,0,1-2,1.92c-2.62,1.34-5.56,1.84-8.41,2.51l-3.38.8c-.19,0-1.22.13-1.34.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.64,182.08a3.5,3.5,0,0,0,4.25-.25l-.66,10.85c2.12,4.86,8,2.78,14.75,11.23,0,0,2.16-3.54.39-10.55l.32-3.64a40.79,40.79,0,0,0,4.28-.31c3-.47,4.56-3.14,5.49-7.14a25.69,25.69,0,0,0,.13-10.9,10.53,10.53,0,0,1-.24-3,13.93,13.93,0,0,0-1-6.34c-3.18-2.42-10.4-3.08-17,1.18.88,4-.58,7.18-3.44,8.78.16,1.07.37,3.79-1.4,3.79-1.28,0-1.41-1.6-2.76-3s-4.41-1.66-5.54.45A6.9,6.9,0,0,0,90.64,182.08Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.87 169.1 116.32 176.42 111.3 177.73 110.87 169.1",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.46,167.92l-2.77,1.37a1.63,1.63,0,0,1,.73-2.12A1.51,1.51,0,0,1,107.46,167.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.08,168.56l-2.74-1.46a1.49,1.49,0,0,1,2-.68A1.63,1.63,0,0,1,118.08,168.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.69,189.72c-4.5-.41-8.06-.84-10.48-4a28.28,28.28,0,0,1-2.85-5.24,21.86,21.86,0,0,0,2.11,6.6c1.18,2.05,4,3.86,11.08,4.27Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.88,171.68a1.26,1.26,0,1,1-1.36-1.22A1.29,1.29,0,0,1,107.88,171.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.72,179.55l5,1.34a2.73,2.73,0,0,1-3.28,1.88A2.54,2.54,0,0,1,106.72,179.55Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91,182.73a3.08,3.08,0,0,0-3.29-2.45,2.52,2.52,0,0,0,1.85,2.49A2.61,2.61,0,0,0,109.91,182.73Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.87,169.83a1.29,1.29,0,0,1,1.24,1.33,1.26,1.26,0,1,1-1.24-1.33",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.12,209.23c.16,4.23-1.92,24.2-2,26.81s4.15,11.05,5,12.49,1.56,1.73,2.57-.36A36.74,36.74,0,0,0,116.47,236c0-4-3.77-22.28-5.16-27.31C111.31,207.33,108.12,207.51,108.12,209.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.12,209.23c.16,4.23-1.92,24.2-2,26.81s4.15,11.05,5,12.49,1.56,1.73,2.57-.36A36.74,36.74,0,0,0,116.47,236c0-4-3.77-22.28-5.16-27.31C111.31,207.33,108.12,207.51,108.12,209.23Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.78,202a14,14,0,0,1-3.47-1.41l-1.82,3.38a18.6,18.6,0,0,0,4.16,1.87,1.82,1.82,0,0,0,1.25-1.29A4.38,4.38,0,0,0,106.78,202Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.78,202a14,14,0,0,1-3.47-1.41l-1.82,3.38a18.6,18.6,0,0,0,4.16,1.87,1.82,1.82,0,0,0,1.25-1.29A4.38,4.38,0,0,0,106.78,202Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.31,198.9a5.79,5.79,0,0,1-1.87,2.42l1.35,3.69s2.4-1.53,2.8-3.47S112.31,198.9,112.31,198.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.31,198.9a5.79,5.79,0,0,1-1.87,2.42l1.35,3.69s2.4-1.53,2.8-3.47S112.31,198.9,112.31,198.9Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.78,202c1.55.41,3.38,0,3.66-.65a5.26,5.26,0,0,1,1.79,4.09,6.47,6.47,0,0,1-.92,3.32s-1-.76-3.19.5a15,15,0,0,1-2.47-3.42S107.12,203.74,106.78,202Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tie--inject-216"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.83,202.12a4.67,4.67,0,0,1-1-.15c-1.09-1.18-1.85-1.84-2.28-1.44a27.81,27.81,0,0,0-2.83,4.85c-.48,1.08-.38,1.08-1.87.09A26.53,26.53,0,0,1,93.09,199a19.56,19.56,0,0,1-2.66-5.33s1.68-2.33,2.18-3.22c1-1.72.92-2.43,1.89-2.28v1.21c.16,1.5,2.33,2.85,4.43,4.66s5.49,3.53,6.29,4.31A45.56,45.56,0,0,1,107.83,202.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,202.83c-.24.61-2.18-4.18-3.14-4.08-.38,0-1,1.67-1.53,2.73a2,2,0,0,1-.89.46c.23-1.61.33-3.5.4-4.15a16.62,16.62,0,0,0-.47-4.43l.32-3.64h.87a15.43,15.43,0,0,1,1.34,1.61c.93,1.53,2.65,4.31,3,6.13A16.29,16.29,0,0,1,115,202.83Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.28,196.44c-6,1.87-10.43,3.89-12.7,9s-6,17.75-8.08,25.39c-1.77,6.55-2.85,12.61-1.31,15.51l17.17-6.88,6.16-17.88S87.65,203.24,82.28,196.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.06,230.56c-1.22,1.62-2.6,2.24-5.6,3.56-2.81,1.24-6,2.4-7.79,5.37.55-2.77,2.11-4.12,5.6-6s8.62-4,8.62-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.06,230.56c-1.22,1.62-2.6,2.24-5.6,3.56-2.81,1.24-6.13,2.08-8.33,5.06-1.8,2.44-2.87,5.24-1.94,7.19.64,1.34,3.84,2.46,8.42,2,3.66-.4,6.23-3.15,10-5.7,3.23-2.18,4.92-3.58,4.92-3.58Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.18,234.16c-1.4-1.31-1.69-2.69-3.74-3.77s-3.31-1-5.48-2-3.93-1.53-5.53-1-1.31,1.5-.08,2.22,3.36,1.67,4.84,2.68,2.91,1.56,3,3.4a81.53,81.53,0,0,1-.37,8.7c-.3,3.09-.83,5.59-.59,5.92s1.57.43,2.32-1.31,1.61-8,1.61-8,.74,4.32,1.07,7.3.51,5.26.61,5.9,2.21.08,2.48-2.19a70.28,70.28,0,0,0-.38-8.93s1.86,3,3,4.92,2.68,4.58,3.16,5.23,1.79-.57,1.41-2.35-2.81-6.1-2.81-6.1,2.87,2.82,3.36,3.09,2,0,1.4-2c-.38-1.31-1.25-2.12-3.57-4.61s-2.32-3.54-3-4.68C83.9,235.08,83.19,235.12,82.18,234.16Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.43,227.41a3,3,0,0,0-.75.44.69.69,0,0,0-.27.73,2.36,2.36,0,0,0,1.25,1.09l3.15,1.58c.52.28,1,.57,1.54.9s1,.62,1.48,1a3.26,3.26,0,0,1,1.59,3.18c0,2.36-.12,4.71-.34,7.06-.12,1.17-.27,2.34-.45,3.5l-.3,1.74a5.69,5.69,0,0,0-.13,1.74,5.47,5.47,0,0,1,0-1.76l.18-1.75c.13-1.17.24-2.33.31-3.5.14-2.34.26-4.69.22-7a3.4,3.4,0,0,0-.24-1.61,3.52,3.52,0,0,0-1.11-1.2c-.47-.33-1-.63-1.47-1s-1-.63-1.47-.92l-3.09-1.71a2.57,2.57,0,0,1-1.25-1.27.8.8,0,0,1,.35-.81A3.06,3.06,0,0,1,67.43,227.41Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.68,235.38c2.25.91,4.39-.16,4.68-.72C81.26,236.2,78.24,237.19,76.68,235.38Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.57,247a1,1,0,0,1-1.39-.05c-.58-.46-2-2-2.66-2.66s-2.87-3.16-2.87-3.16l2.07,3.61s2.87,2.82,3.36,3.09A1.09,1.09,0,0,0,91.57,247Z",
    style: {
      fill: "#f28f8f"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMba);
export default __webpack_public_path__ + "static/media/MBA.26b815d58ae4f4edffe021cd76248f63.svg";
export { ForwardRef as ReactComponent };